<template>
  <div class="Bgc-white">
    <Header />
    <SidebarReservaTop class="barTop" position="top" :infoReserva="infoReserva" />
    <div class="container espacio justify-content-center">
      <div class="row w-100">
        <div class="col-12 col-lg-9">
          <!-- Pasos -->
          <div class="steps">
            <div class="pasos d-inline-block">
              {{ $t('language.posadasCorporate.paymentMethods.text1') }} <i class=" icon-right"></i>
            </div>
            <div class="pasos ativePaso d-inline-block">
              {{ $t('language.posadasCorporate.paymentMethods.text2') }} <i class=" icon-right"></i>
            </div>
            <div class="pasos d-inline-block">
              {{ $t('language.posadasCorporate.paymentMethods.text3') }} <i class=" icon-right"></i>
            </div>
          </div>

          <!-- Metodos de pago -->
          <form @submit.prevent="">
            <div class="metodos">
              <!-- Metodo 1 -->
              <div class="metodo">
                <div class="metodoHeader">
                  <p class="title">
                    {{ $t('language.posadasCorporate.paymentMethods.text4') }}
                  </p>
                </div>
                <div class="metodoBody" role="tablist">
                  <Loader
                    v-if="((!banMetPago.banVaucher && !banMetPago.banTarjCred && !banMetPago.banToken && !banMetPago.banTiemLim && !banMetPago.banCredito) ? true : false)" />
                  <!-- Voucher -->
                  <div class="campos voucher" v-if="banMetPago.banVaucher">
                    <p class="tituloDatos" :class="(iconoActivo == 0) ? 'camposActive' : ''"
                      @click="(iconoActivo == 0) ? iconoActivo = 100 : iconoActivo = 0; sendVoucher()"
                      v-b-toggle="'voucher'">
                      <i class="navi icon-radiobutton-active" :class="(iconoActivo == 0) ? '' : 'oculto'"></i>
                      <i class="navi icon-radiobutto-inactive" :class="(iconoActivo == 0) ? 'oculto' : ''"></i>
                      <i class="icon-voucher"></i>
                      {{ $t('language.posadasCorporate.paymentMethods.text5') }}
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="voucher" accordion="my-accordion" role="tabpanel">
                      <div class="pt-0 pb-16">
                        <span class="PC-text--size14">{{ $t('language.posadasCorporate.paymentMethods.text6') }}.</span>
                      </div>
                      <div class="row">

                        <!-- Folio -->
                        <div class="form-element col-12">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text7') }}</label>
                          <input type="text" name="" id="" v-model="vaucher.folio" @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                        </div>

                        <!-- Politica -->
                        <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchPoliticaVoucher">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text8') }}*</label>

                          <div class="contenidoSearch" @click="[vaucher.tipoPolitica = true]">
                            <i class="search-icons icon-unfold-more" v-if="!vaucher.tipoPolitica"></i>
                            <i class="search-icons icon-close pointer" v-if="vaucher.tipoPolitica"
                              @click="vaucher.politicaSeleccionada = '', filteredPolilticas()"></i>
                            <input class="elipse" type="text" id="vaucher.politicaSeleccionada"  @paste="handlePaste" onkeypress="return (event.charCode != 124)" @keyup="filteredPolilticas()"
                              :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                              v-model="vaucher.politicaSeleccionada" >
                          </div>

                          <div class="card buscadorCard vb" v-if="vaucher.tipoPolitica" v-bar>
                            <div>
                              <div class="buscador" v-for="politica in filteredListPoliticasVoucher" :key="politica.id">
                                <p class="mb-1 nombre" @paste="handlePaste" onkeypress="return (event.charCode != 124)"
                                  @click="[cambiaValuePoliticaVoucher(politica.nombre, politica.code), vaucher.tipoPolitica = 0]"
                                  v-html="$options.filters.resalt(politica.nombre, vaucher.politicaSeleccionada)" ></p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Razon -->
                        <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchRazonVoucher">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text9') }}*</label>

                          <div class="contenidoSearch" @click="[vaucher.tipoRazon = true]">
                            <i class="search-icons icon-unfold-more" v-if="!vaucher.tipoRazon"></i>
                            <i class="search-icons icon-close pointer" v-if="vaucher.tipoRazon"></i>
                            <input class="elipse" type="text"
                              :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                              v-model="vaucher.razonSeleccionada" readonly >
                          </div>

                          <div class="card buscadorCard vb" v-if="vaucher.tipoRazon" v-bar>
                            <div>
                              <div class="buscador" v-for="perfil in filteredListRazonesVoucher" :key="perfil.id">
                                <p class="mb-1 nombre"
                                  @click="[cambiaValueRazonVoucher(perfil.nombre, perfil.razonSe, perfil.code), vaucher.tipoRazon = 0]"
                                  v-html="$options.filters.resalt(perfil.nombre, vaucher.razonSeleccionada)"></p>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </b-collapse>
                  </div>

                  <!-- Tarjeta de crédito -->
                  <div class="campos" v-if="banMetPago.banTarjCred">
                    <p class="tituloDatos" :class="(iconoActivo == 1) ? 'camposActive' : ''"
                      @click="(iconoActivo == 1) ? iconoActivo = 100 : iconoActivo = 1; sendCreditCard(); modalToken(1)"
                      v-b-toggle="'credito'" accordion="my-accordion" role="tabpanel">
                      <i class="navi icon-radiobutton-active" :class="(iconoActivo == 1) ? '' : 'oculto'"></i>
                      <i class="navi icon-radiobutto-inactive" :class="(iconoActivo == 1) ? 'oculto' : ''"></i>
                      <i class="icon-credit-card"></i>
                      {{ $t('language.posadasCorporate.paymentMethods.text10') }}
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="credito" accordion="my-accordion" role="tabpanel">
                      <div class="pt-0 pb-16">
                        <div class="PC-text--size14">
                          {{ $t('language.posadasCorporate.paymentMethods.text11') }}.
                        </div>
                      </div>
                      <div class="row">
                        <!-- Tipo de tarjeta* -->
                        <div class="form-element col-12 col-lg-6">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text12') }}*</label>
                          <div class="contenidoSearch" @click="[credito.tipoTarjeta = true]"
                            v-click-outside="outsideCredito">
                            <i class="search-icons icon-unfold-more" v-if="!credito.tipoTarjeta"></i>
                            <i class="search-icons icon-close pointer" v-if="credito.tipoTarjeta"
                              @click="credito.tarjetaSeleccionada = ''"></i>
                            <input class="elipse" type="text"
                              :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                              v-model="credito.tarjetaSeleccionada" readonly>
                          </div>

                          <div class="card buscadorCard vb" v-if="credito.tipoTarjeta" v-bar>
                            <div>
                              <div class="buscador" v-for="tipoTarjeta in filteredListCredito" :key="tipoTarjeta.id">
                                <p class="mb-1 nombre"
                                  @click="[cambiaCredito(tipoTarjeta.nombre, tipoTarjeta.code), cambiarMascara(tipoTarjeta.code), tipoTarjeta = 0,]"
                                  v-html="$options.filters.resalt(tipoTarjeta.nombre, credito.tarjetaSeleccionada)">
                                </p>
                              </div>

                            </div>
                          </div>
                        </div>

                        <!-- Número de tarjeta* -->
                        <div v-if="this.credito.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-6">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text13') }}*</label>
                          <div class="contenidoSearchCard" @click.prevent="abrirTokenizador()">
                            <i class="search-iconsCards icon-credit-card"></i>
                            <input type="text" class="elipseCards" v-model="credito.numero"
                              :disabled="isDisabledTokenizador"  @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                          </div>
                        </div>
                        <!-- INICIA MODAL NO PUBLICAS Y NO NEGOCIADAS -->
                        <modal v-show="modalTokenizador" @close="cerrarTokenizador()" maxWidth="max-w-500">
                          <template slot="header">
                            <b></b>
                          </template>
                          <template slot="body">
                            <div v-show="!banderilla" v-html="HTMLcontent">
                            </div>
                            <Loader v-if="banderilla" />
                          </template>
                          <template slot="footer">
                            <b></b>
                          </template>
                        </modal>
                        <!-- Nombre de tarjetahabiente* -->
                        <div v-if="this.credito.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-9">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text18') }}*</label>
                          <input class="mayuscula" type="text" v-model="credito.nombre"   @paste="handlePaste" onkeypress="return (event.charCode != 124)"   >

                        </div>

                        <!-- Fecha de expiración* -->
                        <div v-if="this.credito.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-3">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text19') }}*</label>
                          <cleave :class="{ 'is-invalid': (banTarCredExp) }" v-model="fechaExpiracionTarCred"
                            :raw="false" :options="options.date" placeholder="MM/AAAA">
                          </cleave>
                          <span class="notas" v-if="credito.expiracion.length > 0 && credito.expiracion.length < 7">
                            {{ $t('language.posadasCorporate.paymentMethods.text41') }}
                          </span>
                          <span
                            v-if="banTarCredExp && credito.expiracion.length == 7 && validDateExpirationTarCred.tipoError === 2"
                            class="notas">{{ $t('language.posadasCorporate.paymentMethods.text43') }}</span>
                          <span
                            v-if="banTarCredExp && credito.expiracion.length == 7 && validDateExpirationTarCred.tipoError === 1"
                            class="notas">{{ $t('language.posadasCorporate.paymentMethods.text44') }}</span>
                        </div>

                        <!-- Politica -->
                        <div v-if="this.credito.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-6"
                          v-click-outside="outsideSearchPoliticaCredito">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text20') }}</label>

                          <div class="contenidoSearch" @click="[credito.tipoPolitica = true]">
                            <i class="search-icons icon-unfold-more" v-if="!credito.tipoPolitica"></i>
                            <i class="search-icons icon-close pointer"  v-if="credito.tipoPolitica"
                              @click="credito.politicaSeleccionada = '', filteredPolilticas()"></i>
                            <input class="elipse" onkeypress="return (event.charCode != 124)"  type="text" @keyup="filteredPolilticas()"
                              :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                              v-model="credito.politicaSeleccionada" @paste="handlePaste" v-onlyText  >
                          </div>

                          <div class="card buscadorCard vb" v-if="credito.tipoPolitica" v-bar>
                            <div>
                              <div class="buscador" v-for="politica in filteredListPoliticasCredito" :key="politica.id">
                                <p class="mb-1 nombre" @paste="handlePaste" onkeypress="return (event.charCode != 124)"
                                  @click="[cambiaValuePoliticaCredito(politica.nombre), credito.tipoPolitica = 0]"
                                  v-html="$options.filters.resalt(politica.nombre, credito.politicaSeleccionada)"></p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Razon -->
                        <div v-if="this.credito.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-6"
                          v-click-outside="outsideSearchRazonCredito">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text21') }}</label>

                          <div class="contenidoSearch" @click="[credito.tipoRazon = true]">
                            <i class="search-icons icon-unfold-more" v-if="!credito.tipoRazon"></i>
                            <i class="search-icons icon-close pointer" v-if="credito.tipoRazon"></i>
                            <input class="elipse" type="text"
                              :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                              v-model="credito.razonSeleccionada" readonly  >
                          </div>

                          <div class="card buscadorCard vb" v-if="credito.tipoRazon" v-bar>
                            <div>
                              <div class="buscador" v-for="perfil in filteredListRazonesCredito" :key="perfil.id">
                                <p class="mb-1 nombre"
                                  @click="[cambiaValueRazonCredito(perfil.nombre, perfil.razonSe), credito.tipoRazon = 0]"
                                  v-html="$options.filters.resalt(perfil.nombre, credito.razonSeleccionada)"></p>
                              </div>

                            </div>
                          </div>
                        </div>

                      </div>
                    </b-collapse>
                  </div>

                  <!-- Token -->
                  <div class="campos" v-if="banMetPago.banToken">
                    <p class="tituloDatos" :class="(iconoActivo == 2) ? 'camposActive' : ''"
                      @click="(iconoActivo == 2) ? iconoActivo = 100 : iconoActivo = 2; sendToken(); modalToken(2)"
                      v-b-toggle="'token'" accordion="my-accordion" role="tabpanel">
                      <i class="navi icon-radiobutton-active" :class="(iconoActivo == 2) ? '' : 'oculto'"></i>
                      <i class="navi icon-radiobutto-inactive" :class="(iconoActivo == 2) ? 'oculto' : ''"></i>
                      <i class="icon-key"></i>
                      {{ $t('language.posadasCorporate.paymentMethods.text22') }}*
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="token" accordion="my-accordion" role="tabpanel">
                      <div class="pt-0 pb-16">
                        <span class="PC-text--size14">
                          {{ $t('language.posadasCorporate.paymentMethods.text23') }}.
                        </span>
                      </div>
                      <div class="row">
                        <!-- Tipo de tarjeta* -->
                        <div class="form-element col-12 col-lg-6">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text12') }}</label>
                          <div class="contenidoSearch" @click="[token.tipoTarjeta = true]"
                            v-click-outside="outsideToken">
                            <i class="search-icons icon-unfold-more" v-if="!token.tipoTarjeta"></i>
                            <i class="search-icons icon-close pointer" v-if="token.tipoTarjeta"
                              @click="token.tarjetaSeleccionada = ''"></i>
                            <input class="elipse" type="text"
                              :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                              v-model="token.tarjetaSeleccionada" readonly  @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                          </div>



                          <div class="card buscadorCard vb" v-if="token.tipoTarjeta" v-bar>
                            <div>
                              <div class="buscador" v-for="tipoTarjeta in filteredListToken" :key="tipoTarjeta.id">
                                <p class="mb-1 nombre"
                                  @click="[cambiaToken(tipoTarjeta.nombre, tipoTarjeta.code), tipoTarjeta = 0]"
                                  v-html="$options.filters.resalt(tipoTarjeta.nombre, token.tarjetaSeleccionada)"></p>
                              </div>


                            </div>
                          </div>
                        </div>

                        <!-- Número de tarjeta* -->
                        <div v-if="this.token.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-6">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text22') }}</label>
                          <div class="contenidoSearchCard">
                            <i class="search-iconsCards icon-key"></i>
                            <input type="text" class="elipseCards" v-model="token.numero" placeholder="0000000000000000"
                              :disabled="isDisabledTokenizador" v-uppercase @paste="handlePaste" maxlength="16" onkeypress="return (event.charCode != 124)">
                          </div>

                        </div>

                        <!-- Nombre de tarjetahabiente* -->
                        <div v-if="this.token.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-9">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text18') }}*</label>
                          <input class="mayuscula" type="text" name="" id="" v-model="token.nombre" @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                        </div>

                        <!-- Fecha de expiración* -->
                        <div v-if="this.token.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-3">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text19') }}*</label>
                          <cleave :class="{ 'is-invalid': (banTokenExp) }" v-model="fechaExpiracionToken" :raw="false"
                            :options="options.date" placeholder="MM/AAAA"  @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                          </cleave>
                          <span class="notas" v-if="token.expiracion.length > 0 && token.expiracion.length < 7">
                            {{ $t('language.posadasCorporate.paymentMethods.text41') }}
                          </span>
                          <span
                            v-if="banTokenExp && token.expiracion.length == 7 && validDateExpirationToken.tipoError === 2"
                            class="notas">{{ $t('language.posadasCorporate.paymentMethods.text42') }}</span>
                          <span
                            v-if="banTokenExp && token.expiracion.length == 7 && validDateExpirationToken.tipoError === 1"
                            class="notas">{{ $t('language.posadasCorporate.paymentMethods.text44') }}</span>
                        </div>

                        <!-- Politica -->
                        <div v-if="this.token.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-6"
                          v-click-outside="outsideSearchPoliticaToken">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text20') }}</label>

                          <div class="contenidoSearch" @click="[token.tipoPolitica = true]">
                            <i class="search-icons icon-unfold-more" v-if="!token.tipoPolitica"></i>
                            <i class="search-icons icon-close pointer" v-if="token.tipoPolitica"
                              @click="token.politicaSeleccionada = '', filteredPolilticas()"></i>
                            <input class="elipse"  type="text" @keyup="filteredPolilticas()" id="politica2"
                              :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                              v-model="token.politicaSeleccionada" @paste="handlePaste" onkeypress="return (event.charCode != 124)"  >
                          </div>

                          <div class="card buscadorCard vb" v-if="token.tipoPolitica" v-bar>
                            <div>
                              <div class="buscador" v-for="politica in filteredListPoliticasToken" :key="politica.id">
                                <p class="mb-1 nombre" @paste="handlePaste" onkeypress="return (event.charCode != 124)"
                                  @click="[cambiaValuePoliticaToken(politica.nombre), token.tipoPolitica = 0]"
                                  v-html="$options.filters.resalt(politica.nombre, token.politicaSeleccionada)"></p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Razon -->
                        <div v-if="this.token.tarjetaSeleccionada.length > 2" class="form-element col-12 col-lg-6"
                          v-click-outside="outsideSearchRazonToken">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text21') }}</label>

                          <div class="contenidoSearch" @click="[token.tipoRazon = true]">
                            <i class="search-icons icon-unfold-more" v-if="!token.tipoRazon"></i>
                            <i class="search-icons icon-close pointer" v-if="token.tipoRazon"></i>
                            <input class="elipse" type="text"
                              :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                              v-model="token.razonSeleccionada" readonly >
                          </div>

                          <div class="card buscadorCard vb" v-if="token.tipoRazon" v-bar>
                            <div>
                              <div class="buscador" v-for="perfil in filteredListRazonesToken" :key="perfil.id">
                                <p class="mb-1 nombre"
                                  @click="[cambiaValueRazonToken(perfil.nombre, perfil.razonSe), token.tipoRazon = 0]"
                                  v-html="$options.filters.resalt(perfil.nombre, token.razonSeleccionada)"></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <!-- Tiempo límite -->
                  <div class="campos limite" v-if="banMetPago.banTiemLim">
                    <p class="tituloDatos" :class="(iconoActivo == 3) ? 'camposActive' : ''"
                      @click="(iconoActivo == 3) ? iconoActivo = 100 : iconoActivo = 3; sendTimeLimit()"
                      v-b-toggle="'tiempoLimite'" accordion="my-accordion" role="tabpanel">
                      <i class="navi icon-radiobutton-active" :class="(iconoActivo == 3) ? '' : 'oculto'"></i>
                      <i class="navi icon-radiobutto-inactive" :class="(iconoActivo == 3) ? 'oculto' : ''"></i>
                      <i class="icon-time"></i>
                      {{ $t('language.posadasCorporate.paymentMethods.text30') }}
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="tiempoLimite" accordion="my-accordion" role="tabpanel">
                      <div class="pt-0 pb-16">
                        <span class="PC-text--size14">
                          {{ $t('language.posadasCorporate.paymentMethods.text31') }}.
                        </span>
                      </div>
                      <div class="row">
                        <!-- Politica -->
                        <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchPoliticaTiempo">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text32') }}</label>

                          <div class="contenidoSearch" @click="[tiempoLimite.tipoPolitica = true]">
                            <i class="search-icons icon-unfold-more" v-if="!tiempoLimite.tipoPolitica"></i>
                            <i class="search-icons icon-close pointer" v-if="tiempoLimite.tipoPolitica"
                              @click="tiempoLimite.politicaSeleccionada = '', filteredPolilticas()"></i>
                            <input class="elipse" type="text" @keyup="filteredPolilticas()" 
                            @paste="handlePaste" onkeypress="return (event.charCode != 124)"
                              :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                              v-model="tiempoLimite.politicaSeleccionada"  >
                          </div>
                          <div class="card buscadorCard vb" v-if="tiempoLimite.tipoPolitica" v-bar>
                            <div>
                              <div class="buscador" v-for="politica in filteredListPoliticasTiempo" :key="politica.id">
                                <p class="mb-1 nombre" @paste="handlePaste" onkeypress="return (event.charCode != 124)"
                                  @click="[cambiaValuePoliticaTiempo(politica.nombre), tiempoLimite.tipoPolitica = 0]"
                                  v-html="$options.filters.resalt(politica.nombre, tiempoLimite.politicaSeleccionada)">
                                </p>
                              </div>

                            </div>
                          </div>
                        </div>
                        <!-- Razon -->
                        <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchRazonTiempo">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text29') }}</label>

                          <div class="contenidoSearch" @click="[tiempoLimite.tipoRazon = true]">
                            <i class="search-icons icon-unfold-more" v-if="!tiempoLimite.tipoRazon"></i>
                            <i class="search-icons icon-close pointer" v-if="tiempoLimite.tipoRazon"></i>
                            <input class="elipse" type="text"
                              :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                              v-model="tiempoLimite.razonSeleccionada" readonly >
                          </div>

                          <div class="card buscadorCard vb" v-if="tiempoLimite.tipoRazon" v-bar>
                            <div>
                              <div class="buscador" v-for="perfil in filteredListRazonesTiempo" :key="perfil.id">
                                <p class="mb-1 nombre"
                                  @click="[cambiaValueRazonTiempo(perfil.nombre, perfil.razonSe), tiempoLimite.tipoRazon = 0]"
                                  v-html="$options.filters.resalt(perfil.nombre, tiempoLimite.razonSeleccionada)"></p>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </b-collapse>
                  </div>

                  <!-- Credito -->
                  <div class="campos voucher" v-if="banMetPago.banCredito">
                    <p class="tituloDatos" :class="(iconoActivo == 4) ? 'camposActive' : ''"
                      @click="(iconoActivo == 4) ? iconoActivo = 100 : iconoActivo = 4; sendCreditPay()"
                      v-b-toggle="'creditoEmpresa'">
                      <i class="navi icon-radiobutton-active" :class="(iconoActivo == 4) ? '' : 'oculto'"></i>
                      <i class="navi icon-radiobutto-inactive" :class="(iconoActivo == 4) ? 'oculto' : ''"></i>
                      <i class="icon-currency"></i>
                      {{ $t('language.posadasCorporate.paymentMethods.text33') }}
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="creditoEmpresa" accordion="my-accordion" role="tabpanel">
                      <div class="pt-0 pb-16">
                        <span class="PC-text--size14">
                          {{ $t('language.posadasCorporate.paymentMethods.text34') }}.
                        </span>
                      </div>
                      <div class="row">

                        <!-- Folio -->
                        <div class="form-element col-12">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text35') }}</label>
                          <input type="text" name="" id="" v-model="creditoEmpresa.folio" @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                        </div>

                        <!-- Politica -->
                        <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchPoliticaCreditoEmpresa">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text28') }}*</label>

                          <div class="contenidoSearch" @click="[creditoEmpresa.tipoPolitica = true]">
                            <i class="search-icons icon-unfold-more" v-if="!creditoEmpresa.tipoPolitica"></i>
                            <i class="search-icons icon-close pointer" v-if="creditoEmpresa.tipoPolitica"
                              @click="creditoEmpresa.politicaSeleccionada = '', filteredPolilticas()"></i>
                            <input class="elipse" type="text" @keyup="filteredPolilticas()"
                              :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                              v-model="creditoEmpresa.politicaSeleccionada"  @paste="handlePaste" onkeypress="return (event.charCode != 124)">
                          </div>



                          <div class="card buscadorCard vb" v-if="creditoEmpresa.tipoPolitica" v-bar>
                            <div>
                              <div class="buscador" v-for="politica in filteredListPoliticasCreditoEmpresa"
                                :key="politica.id">
                                <p class="mb-1 nombre" @paste="handlePaste" onkeypress="return (event.charCode != 124)"
                                  @click="[cambiaValuePoliticaCreditoEmpresa(politica.nombre, politica.code), creditoEmpresa.tipoPolitica = 0]"
                                  v-html="$options.filters.resalt(politica.nombre, creditoEmpresa.politicaSeleccionada)">
                                </p>
                              </div>

                            </div>
                          </div>
                        </div>

                        <!-- Razon -->
                        <div class="form-element col-12 col-lg-6" v-click-outside="outsideSearchRazonCreditoEmpresa">
                          <label>{{ $t('language.posadasCorporate.paymentMethods.text29') }}*</label>

                          <div class="contenidoSearch" @click="[creditoEmpresa.tipoRazon = true]">
                            <i class="search-icons icon-unfold-more" v-if="!creditoEmpresa.tipoRazon"></i>
                            <i class="search-icons icon-close pointer" v-if="creditoEmpresa.tipoRazon"></i>
                            <input class="elipse" type="text"
                              :placeholder="$t('language.posadasCorporate.paymentMethods.select')"
                              v-model="creditoEmpresa.razonSeleccionada" readonly>
                          </div>
                          <div class="card buscadorCard vb" v-if="creditoEmpresa.tipoRazon" v-bar>
                            <div>
                              <div class="buscador" v-for="perfil in filteredListRazonesCreditoEmpresa"
                                :key="perfil.id">
                                <p class="mb-1 nombre"
                                  @click="[cambiaValueRazonCreditoEmpresa(perfil.nombre, perfil.razonSe, perfil.code), creditoEmpresa.tipoRazon = 0]"
                                  v-html="$options.filters.resalt(perfil.nombre, creditoEmpresa.razonSeleccionada)">
                                </p>
                              </div>

                            </div>
                          </div>
                        </div>

                      </div>
                    </b-collapse>
                  </div>

                  <!-- CREDIT METHODS IS TEMPORIRILY HIDDEN -->

                </div>
              </div>
              <!-- Metodo 2-->
              <div class="metodo mt-5">
                <div class="metodoHeader">
                  <p class="title">
                    {{ $t('language.posadasCorporate.paymentMethods.text36') }}
                  </p>
                </div>
                <div class="metodoBody">
                  <div class="campos" v-for="(item, index) in policyChangeCancelation" :key="'policies' + index">
                    <p class="tituloDatos"
                      @click="(iconoNaviActivo == index) ? iconoNaviActivo = 100 : iconoNaviActivo = index"
                      v-b-toggle="'policy' + index">
                      {{ item.title }}
                      <i class="navi2 icon-up" :class="(iconoNaviActivo == index) ? 'camposActive' : 'oculto'"></i>
                      <i class="navi2 icon-navigate-down" :class="(iconoNaviActivo == index) ? 'oculto' : ''"></i>
                    </p>
                    <!-- Formulario -->
                    <b-collapse class="datos" :id="'policy' + index">
                      <div class="row">

                        <div class="col-12" v-if="banTitleBusquedaTarifa == false"> 
                        <!-- KB48764 m.a.cortes Modificacion de monto CYC -->
                          <p>{{changePolicys(item.description ,ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.totalRateWithoutTaxes ,item.penaltyQuantity, guiones,tipoTarifa,tipoClienteID, ls.get('updateCostDetail').data.hotel.nights)}}
                      
                          </p>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                  <div class="d-flex flex-row mt-5">
                    <input class="mt-1 mr-2" type="checkbox" v-model="aceptoAviso" @click="modalCheckbox()"
                      :disabled="isDisabledCheckbox">
                    <span class="">
                      {{ $t('language.posadasCorporate.paymentMethods.text37') }}
                      <span class="notaAzul cursor"
                        @click="redirecAvisoPrivacidad">{{ $t('language.posadasCorporate.paymentMethods.text38') }}.</span>*
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <Loader v-if="banTitleBusquedaTarifa" />
            <!-- Botones -->
            <div class="row botones">
              <div class="col-12 col-lg-6 botonesInfo order-2 order-lg-1">
                <button class="secondary-button"
                  @click="goReservationForm()">{{ $t('language.posadasCorporate.paymentMethods.text39') }}</button>
              </div>
              <div class="col-12 col-lg-6 botonesInfo order-1 order-lg-2 mb-2 mb-lg-0">
                <button class="button" @click="goReservacionesConfirmacion"
                  :disabled="isDisabled || banTitleBusquedaTarifa">{{ $t('language.posadasCorporate.paymentMethods.text40') }}</button>
              </div>
            </div>
          </form>
        </div>
        <div class="col-12 col-lg-3">
          <div class="info">
            <sidebar-reserva :infoReserva="infoReserva" :banRequeriment="true" class="barRight"></sidebar-reserva>
          </div>
        </div>
      </div>
    </div>
    <Footer />

    <modal v-show="isModalVisible" @close="closeModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i>
          {{ modalTokenCreditoSaveUpdate.title }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ modalTokenCreditoSaveUpdate.body }}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="secondary-button" @click="modalSaveUpdate(2)" aria-label="Close modal">
          {{ $t('language.posadasCorporate.paymentMethods.modales.usarToken.noGuardar') }}
        </button>
        <button type="button" class="primary-button" @click="modalSaveUpdate(1)" aria-label="Close modal">
          {{ $t('language.posadasCorporate.paymentMethods.modales.usarToken.guardar') }}
        </button>
      </template>
    </modal>

    <modal v-show="banModalTokenInexistente" @close="banModalTokenInexistente = false" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i>
          {{ $t('language.posadasCorporate.paymentMethods.modales.tokenInexistente.title') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.paymentMethods.modales.tokenInexistente.body') }}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="primary-button" @click="banModalTokenInexistente = false" aria-label="Close modal">
          {{ $t('language.posadasCorporate.paymentMethods.modales.tokenInexistente.button') }}
        </button>
      </template>
    </modal>

    <modal v-show="isModalVisibleUsarToken" @close="closeModalToken" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ modalTokenCredito.title }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ modalTokenCredito.body }}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="secondary-button" @click="closeModalToken" aria-label="Close modal">
          {{ $t('language.posadasCorporate.paymentMethods.modales.usarToken.no') }}
        </button>
        <button type="button" class="primary-button" @click="modalTokenCreditYes()" aria-label="Close modal">
          {{ $t('language.posadasCorporate.paymentMethods.modales.usarToken.si') }}
        </button>
      </template>
    </modal>


    <!-- EXPIRED SESSION MODAL  -->
    <modal v-show="isExpiredModalVisible" @close="closeExpiredModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{
            $t('language.posadasCorporate.modales.expiredSession.title')
        }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.modales.expiredSession.body') }}
        </p>
      </template>
      <template slot="footer">

        <button type="button" class="button btn-primary" @click="closeExpiredModal" aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.expiredSession.button') }}
        </button>
      </template>
    </modal>
    <!-- EXPIRED SESSION MODAL  -->

    <!-- PAS DE CONFORMATION ICI NOM 1-->
    <modal v-show="pasConfirmation" @close="pasConfirmationModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{
            $t('language.posadasCorporate.modales.pasConfirmation.title')
        }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ pasConfirmationBody }}
        </p>
      </template>
      <template slot="footer">

        <button type="button" class="button btn-primary" @click="pasConfirmationModal" aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.pasConfirmation.button') }}
        </button>
      </template>
    </modal>
    <!-- FIN DE CONFORMATION ICI NOM 1-->



    <!-- PAS DE CONFORMATION ICI NOM 2-->
    <modal v-show="pasConfirmation2" @close="pasConfirmationModal2" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{
            $t('language.posadasCorporate.modales.reservacionCancelacion.headError')
        }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.modales.reservacionCancelacion.bodyError') }}
        </p>
      </template>
      <template slot="footer">

        <button type="button" class="button btn-primary" @click="pasConfirmationModal2" aria-label="Close modal">
          {{ $t('language.posadasCorporate.recuperarPassword.continuar') }}
        </button>
      </template>
    </modal>
    <!-- FIN DE CONFORMATION ICI NOM 2-->

    <modal v-if="banError6" @close="error6Modal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{
            $t('language.posadasCorporate.modales.pasConfirmation.title')
        }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ error6Body }}
        </p>
      </template>
      <template slot="footer">

        <button type="button" class="button btn-primary" @click="error6Modal" aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.pasConfirmation.button') }}
        </button>
      </template>
    </modal>


  </div>
</template>
<script>
import * as GlobalFunctions from '../../../utils/GlobalFunctions';
import * as GlobalServices from '../../../utils/GlobalServices';
import Header from '../../generales/Header.vue';
import SidebarReserva from '../SidebarReserva.vue';
import SidebarReservaTop from '../SidebarReservaTop.vue';
import Footer from '../../generales/Footer.vue';
import axios from 'axios';
import SecureLS from 'secure-ls';
import Modal from '../../addons/Modal.vue'
import i18n from '../../../plugins/i18n';
import Loader from '../../loader/Loader';
import Cleave from 'vue-cleave-component';

export default {
  name: 'ReservacionesMetodosPago',
  components: {
    Loader,
    Header,
    SidebarReserva,
    SidebarReservaTop,
    Footer,
    Modal,
    Cleave
  },
  data: () => {
    return {
      banError6: false,
      error6Body: '',
      isUserGeneric: false,
      politicasList: [],
      banSelectedPoliticaVaucher: false,
      banSelectedPoliticaCredito: false,
      banSelectedPoliticaToken: false,
      banSelectedPoliticaCreditoEmpresa: false,
      banSelectedPoliticaTiempoLimite: false,
      tipoClienteID: '',
      pyp: 'PYP', //no cambiar este valor
      pypsa: 'PYPSA', //no cambiar este valor
       guiones: '-------',
      twoPolicy: 'igual a 2',
      twoPolicyEn: 'equal to 2',
      tipoTarifa: 0,
      banderilla: true,
      validDateExpirationTarCred: null,
      validDateExpirationToken: null,
      contPoliticaSelectedDefault: 0,
      banPoliticaSelectedDefault: false,
      contRazonSelectedDefault: 0,
      banRazonSelectedDefault: false,
      totalCost2S: 0,
      businessRa: "",
      options: {
        date: {
          date: true,
          datePattern: ['m', 'Y'],
          delimiter: '/',
        },
      },
      banModalTokenInexistente: false,
      banTokenInexistente: false,
      banGuardaToken: false,
      banTarCredExp: false,
      fechaExpiracionTarCred: '',
      banTokenExp: false,
      fechaExpiracionToken: '',
      pasConfirmationBody: '',
      modalTokenCredito: {
        title: null,
        body: null,
        modalNumberToken: null,
        lugar: null
      },
      modalTokenCreditoSaveUpdate: {
        title: null,
        body: null
      },
      saveOrUpdate: '',
      modalNumberToken: null,
      dataTokenExist: null,
      isModalVisible: false,
      isModalVisibleUsarToken: false,
      enableLoader: true,
      pasConfirmation: false,
      pasConfirmation2: false,
      banMetPago: {
        banVaucher: false,
        banTarjCred: false,
        banToken: false,
        banTiemLim: false,
        banCredito: false
      },
      showCreditSilVousPlait: false,
      tokenCreditCardType: '',
      cardTypeForService: '',
      banTitleBusquedaTarifa: false,
      findPaymentMethod: [],
      isCreditPayment: false,
      isTimeLimitPayment: false,
      isTokenPayment: false,
      isCreditCardPayment: false,
      isVoucherPayment: false,
      isExpiredModalVisible: false,
      ls: new SecureLS({ encodingType: 'aes' }),
      infoReserva: null,
      modalTokenizador: false,
      token: '',
      language: '',
      device: 'desktop',
      iconoActivo: 99,
      iconoNaviActivo: 99,
      vaucher: {
        folio: '',
        // Politicas
        tipoPolitica: false,
        politicaSeleccionada: '',
        politicaSeleccionadaCode: '',
        politicas: [],
        // Razon
        tipoRazon: false,
        razonSeleccionada: '',
        razonSeleccionadaCode: '',
        razones: [],
      },
      credito: {
        //tarjetas
        tipoTarjeta: false,
        tarjetaSeleccionada: '',
        tarjetas: [],
        tipoDeMascara: '',
        numero: '',
        nombre: '',
        expiracion: '',
        // Politicas
        tipoPolitica: false,
        politicaSeleccionada: '',
        politicas: [],
        // Razon
        tipoRazon: false,
        razonSeleccionada: '',
        razones: [],
      },
      token: {
        //tarjetas
        tipoTarjeta: false,
        tarjetaSeleccionada: '',
        tarjetas: [],
        numero: '',
        nombre: '',
        expiracion: '',
        // Politicas
        tipoPolitica: false,
        politicaSeleccionada: '',
        politicas: [],
        // Razon
        tipoRazon: false,
        razonSeleccionada: '',
        razones: [],
      },
      tiempoLimite: {
        // Politicas
        tipoPolitica: false,
        politicaSeleccionada: '',
        politicas: [],
        // Razon
        tipoRazon: false,
        razonSeleccionada: '',
        razones: [],
      },
      creditoEmpresa: {
        folio: '',
        // Politicas
        tipoPolitica: false,
        politicaSeleccionada: '',
        politicaSeleccionadaCode: '',
        politicas: [],
        // Razon
        tipoRazon: false,
        razonSeleccionada: '',
        razonSeleccionadaCode: '',
        razones: [],
      },
      aceptoAviso: false,
      policyChangeCancelation: [],

      urlTokenizado: '',
      HTMLcontent: '',
      statusLoader: true,
      loaded: false,
    }
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth);
      this.getWindowWidth();
    });
  },
  created() {
    this.isUserGeneric = this.ls.get('isUserGeneric').data;
    this.callGuestDetail();
    this.detalleTarifa();
    this.consultaMetodosPago();
    this.politicaViajeRazonSocial();
    this.ls.set('fixA', false)
    this.ls.set('supplDeta', true)
    var local1 = this.ls.get('datosHabHotSelected')
    this.tipoTarifa = this.ls.get('datosHabHotSelected').data.tabActive;
    this.tipoClienteID = this.ls.get('ClientId').data;
    local1.data.politicas.listPoliticas.forEach(e => {
      if (e == null || e.title == null) return;
      this.policyChangeCancelation.push(e);
    });
  },
  destroyed() {
    this.ls.remove('GuestProfileDetail');
  },
  watch: {
    fechaExpiracionTarCred() {
      this.credito.expiracion = this.fechaExpiracionTarCred;
      if (this.fechaExpiracionTarCred.length === 7) {
        var mes = this.fechaExpiracionTarCred.substring(0, 2);
        var ano = this.fechaExpiracionTarCred.substring(3, 7);
        this.validDateExpirationTarCred = GlobalFunctions.IsValidDateExpiration(mes, ano);
        this.banTarCredExp = this.validDateExpirationTarCred.banDate;
      } else {
        this.banTarCredExp = true;
      }
    },
    fechaExpiracionToken() {
      this.token.expiracion = this.fechaExpiracionToken;
      if (this.fechaExpiracionToken.length === 7) {
        var mes = this.fechaExpiracionToken.substring(0, 2);
        var ano = this.fechaExpiracionToken.substring(3, 7);
        this.validDateExpirationToken = GlobalFunctions.IsValidDateExpiration(mes, ano);
        this.banTokenExp = this.validDateExpirationToken.banDate;
      } else {
        this.banTokenExp = true;
      }
    }
  },
  methods: {
       handlePaste(event ) {
       const lang=this.ls.get('Language').data;
       console.log("value for this.language"+lang);
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (pastedText.includes('|')) {           
        event.preventDefault();
         if(lang == 'es'){
           alert('El carácter "|" no está permitido al pegar texto.');           
        }else{
           alert('The "|" character is not allowed when pasting text');
        }
          
      }
     
  },
    error6Modal() {
      this.banError6 = false;
      this.$router.push({ name: 'Reservaciones' });
    },
     handleInput(i) {
       this.i = this.i.replace(/\|/g, '');
       //alert('El carácter "|" no está permitido al pegar texto.');
    //  this.filteredPolilticas();
    },
           handlePaste(event ) {
              const lang=this.ls.get('Language').data;
              console.log("value for this.language"+lang);
              const pastedText = (event.clipboardData || window.clipboardData).getData('text');
              if (pastedText.includes('|')) {           
                event.preventDefault();
                if(lang == 'es'){
                  alert('El carácter "|" no está permitido al pegar texto.');           
                }else{
                  alert('The "|" character is not allowed when pasting text');
                }
                  
      }
    },
    restrictChars(e) {
     // console.log("value e"+e);
      var input = document.getElementById(e).value ;
      if(input.includes('|')){
        document.getElementById(e).value =   input.replace("|", '');
      }
      var input2 = document.getElementById(e).value ;
      if(input2.includes('|')){    
        document.getElementById(e).value =   input2.replace("|", '');
        }
      },

    filteredPolilticas() {
      switch (this.iconoActivo) {
        case 0:
          //vaucher
         
          return this.vaucher.politicas = this.politicasList.filter(pol => {
            return pol.nombre.toLowerCase().includes(this.vaucher.politicaSeleccionada.toLowerCase())
          });
          break;
        case 1:
          //credito
        
          return this.credito.politicas = this.politicasList.filter(pol => {
            return pol.nombre.toLowerCase().includes(this.credito.politicaSeleccionada.toLowerCase())
          });
          break;
        case 2:
          //token
       
          return this.token.politicas = this.politicasList.filter(pol => {
            return pol.nombre.toLowerCase().includes(this.token.politicaSeleccionada.toLowerCase())
          });
          break;
        case 3:
          //tiempo limite
      
          return this.tiempoLimite.politicas = this.politicasList.filter(pol => {
            return pol.nombre.toLowerCase().includes(this.tiempoLimite.politicaSeleccionada.toLowerCase())
          });
          break;
        case 4:
          //credito empresa
      
          return this.creditoEmpresa.politicas = this.politicasList.filter(pol => {
            return pol.nombre.toLowerCase().includes(this.creditoEmpresa.politicaSeleccionada.toLowerCase())
          });
          break;
      }
    },
    validadorPreferenciasVacias(tipoPreferencia) {
      var totalPreferences = [];
      if (this.ls.get('requirementsDataH' + tipoPreferencia) != {} && this.ls.get('requirementsDataH' + tipoPreferencia) != '') {
        if (this.ls.get('requirementsDataH' + tipoPreferencia).extraPreferences.length > 0) {
          totalPreferences = totalPreferences.concat(this.ls.get('requirementsDataH' + tipoPreferencia).extraPreferences)
        }

        if (this.ls.get('requirementsDataH' + tipoPreferencia).preferences.length > 0) {
          totalPreferences = totalPreferences.concat(this.ls.get('requirementsDataH' + tipoPreferencia).preferences)
        }

        if (this.ls.get('requirementsDataH' + tipoPreferencia).floorPreferences !== '') {
          totalPreferences = totalPreferences.concat(this.ls.get('requirementsDataH' + tipoPreferencia).floorPreferences)
        }

        if (this.ls.get('requirementsDataH' + tipoPreferencia).smokingPreferences !== '') {
          totalPreferences = totalPreferences.concat(this.ls.get('requirementsDataH' + tipoPreferencia).smokingPreferences)
        }
      }
      return totalPreferences;
    },
    modalSaveUpdate(lugar) {
      if (lugar === 1) {
        if ((this.modalTokenCredito.lugar === 1 || this.modalTokenCredito.lugar === 2) && this.dataTokenExist.guaranteeNumber !== '') {
          this.saveOrUpdate = 'UPDATE';
        }
        if ((this.modalTokenCredito.lugar === 1 || this.modalTokenCredito.lugar === 2) && this.dataTokenExist.guaranteeNumber === '') {
          this.saveOrUpdate = 'SAVE';
        }
      }
      if (lugar === 2) {
        this.saveOrUpdate = '';
      }

      this.closeModal();
    },
    getBrowserForCheckbox(boleano) {
      var navegador = GlobalFunctions.getBrowserInfo().toLowerCase();
      if (navegador.search('ie') > -1 || navegador.search('edge') > -1) {
        return !boleano;
      } else {
        return boleano;
      }

    },
    modalCheckbox() {
      this.$store.commit('setSidebar', true);
      if (!this.isUserGeneric) {
        const contactDataH1 = this.ls.get('contactDataH1');
        var tipoTar = '';
        for (let i = 0; i < this.credito.tarjetas.length; i++) {
          if (this.credito.tarjetas[i].code === this.dataTokenExist.guaranteeType) {
            tipoTar = this.credito.tarjetas[i].nombre
          }
        }

        var tipoTok = '';
        for (let ii = 0; ii < this.token.tarjetas.length; ii++) {
          if (this.token.tarjetas[ii].code === this.dataTokenExist.guaranteeType) {
            tipoTok = this.token.tarjetas[ii].nombre
          }
        }
        if (!this.getBrowserForCheckbox(this.aceptoAviso) && (this.iconoActivo === 1 || this.iconoActivo === 2)
          && ((this.iconoActivo === 1 && (this.dataTokenExist.guaranteeNumber !== this.credito.numero || this.dataTokenExist.expirationDate !== this.credito.expiracion || this.dataTokenExist.holderName.toUpperCase() !== this.credito.nombre.toUpperCase() || tipoTar !== this.credito.tarjetaSeleccionada))
            || (this.iconoActivo === 2 && (this.dataTokenExist.guaranteeNumber !== this.token.numero || this.dataTokenExist.expirationDate !== this.token.expiracion || this.dataTokenExist.holderName.toUpperCase() !== this.token.nombre.toUpperCase() || tipoTok !== this.token.tarjetaSeleccionada)))
          && !(!contactDataH1.saveNewProfileH1 && this.dataTokenExist.guaranteeNumber == '' && !this.banGuardaToken) && !this.banTokenInexistente) {

          if (this.modalTokenCredito.lugar === 1 && this.dataTokenExist.guaranteeNumber !== '') {
            this.modalTokenCreditoSaveUpdate.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.actualizarTarjetaCredito');
            this.modalTokenCreditoSaveUpdate.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text4');
          }
          if (this.modalTokenCredito.lugar === 1 && this.dataTokenExist.guaranteeNumber === '') {
            this.modalTokenCreditoSaveUpdate.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.guardadoTarjeta');
            this.modalTokenCreditoSaveUpdate.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text3');
          }

          if (this.modalTokenCredito.lugar === 2 && this.dataTokenExist.guaranteeNumber !== '') {
            this.modalTokenCreditoSaveUpdate.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.actualizarToken');
            this.modalTokenCreditoSaveUpdate.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text6');
          }
          if (this.modalTokenCredito.lugar === 2 && this.dataTokenExist.guaranteeNumber === '') {
            this.modalTokenCreditoSaveUpdate.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.guardadoToken');
            this.modalTokenCreditoSaveUpdate.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text5');
          }

          this.isModalVisible = true;
        }
      }
    },
    modalToken(lugar) {
      /** lugar
       * 1: tarjeta credito
       * 2: token
       */
      this.modalTokenCredito.lugar = lugar;
      var nameComponent = window.location.pathname;
      if (this.dataTokenExist.guaranteeNumber !== '' && (this.iconoActivo === 1 || this.iconoActivo === 2)) {

        if (this.mostrarTipoTarjetaAutocompleteToken(this.dataTokenExist.guaranteeType) === undefined) {
          this.banModalTokenInexistente = true;
          this.banTokenInexistente = true;
        } else {
          if (lugar == 1) {
            this.modalTokenCredito.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.tarjetaGuardado');
            this.modalTokenCredito.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text2') + ' ' + this.dataTokenExist.guaranteeNumber.substring(0, this.dataTokenExist.guaranteeNumber.length - 4).replace(/./g, "*") + ' ' + this.dataTokenExist.guaranteeNumber.substring(this.dataTokenExist.guaranteeNumber.length - 4) + '?';
            this.modalTokenCredito.modalNumberToken = this.dataTokenExist.guaranteeNumber;
          }
          if (lugar == 2) {
            this.modalTokenCredito.title = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.tokenGuardado');
            this.modalTokenCredito.body = i18n.t('language.posadasCorporate.paymentMethods.modales.usarToken.text1') + ' ' + this.dataTokenExist.guaranteeNumber.substring(0, this.dataTokenExist.guaranteeNumber.length - 4).replace(/./g, "*") + ' ' + this.dataTokenExist.guaranteeNumber.substring(this.dataTokenExist.guaranteeNumber.length - 4) + '?';
            this.modalTokenCredito.modalNumberToken = this.dataTokenExist.guaranteeNumber;
          }
          this.isModalVisibleUsarToken = true;
        }

      }
    },
    modalTokenCreditYes() {
      if (this.modalTokenCredito.lugar === 1) {
        //tarjeta de credito
        this.credito.tarjetaSeleccionada = this.mostrarTipoTarjetaAutocompleteToken(this.dataTokenExist.guaranteeType).nombre; //guaranteeType
        this.cardTypeForService = this.dataTokenExist.guaranteeType;
        this.credito.tipoDeMascara = this.dataTokenExist.guaranteeNumber;
        this.credito.numero = this.dataTokenExist.guaranteeNumber;
        this.credito.nombre = this.dataTokenExist.holderName;
        this.credito.expiracion = this.dataTokenExist.expirationDate.replace('/', '');
        this.fechaExpiracionTarCred = this.dataTokenExist.expirationDate.replace('/', '');
      }
      if (this.modalTokenCredito.lugar === 2) {
        //token
        this.token.tarjetaSeleccionada = this.mostrarTipoTarjetaAutocompleteToken(this.dataTokenExist.guaranteeType).nombre; //guaranteeType
        this.tokenCreditCardType = this.dataTokenExist.guaranteeType;
        this.token.numero = this.dataTokenExist.guaranteeNumber;
        this.token.nombre = this.dataTokenExist.holderName;
        this.token.expiracion = this.dataTokenExist.expirationDate.replace('/', '');
        this.fechaExpiracionToken = this.dataTokenExist.expirationDate.replace('/', '');
      }
      this.closeModalToken();
    },
    mostrarTipoTarjetaAutocompleteToken(buscar) {
      if (this.modalTokenCredito.lugar === 1) {
        return this.credito.tarjetas.find(lista => lista.code === buscar);
      }
      if (this.modalTokenCredito.lugar === 2) {
        return this.token.tarjetas.find(lista => lista.code === buscar);
      }

    },
    callGuestDetail() {
      if (this.ls.get('GuestProfileDetail') === '') {
        var data = {
          cardInfoResponse: {
            profileIdUser: '',
            guaranteeIdUser: '',
            expirationDate: '',
            guaranteeNumber: '',
            holderName: '',
            userId: '',
            guaranteeType: '',
            isCreditCard: '',
            decriptionGuaranteeType: '',
            street1: '',
            street2: '',
            zipCode: '',
            countryCode: '',
            state: '',
            city: ''
          }
        }
        this.banGuardaToken = false;
        this.ls.set('GuestProfileDetail', { data: data });
      } else {
        this.banGuardaToken = true;
      }
      this.dataTokenExist = this.ls.get('GuestProfileDetail').data.cardInfoResponse;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    closeModalToken() {
      this.isModalVisibleUsarToken = false;
    },
    pasConfirmationModal() {
      this.pasConfirmation = false
      this.banTitleBusquedaTarifa = false
    },
    pasConfirmationModal2() {
      this.pasConfirmation2 = false
      this.banTitleBusquedaTarifa = false


    },
    redirecAvisoPrivacidad() {
      (this.ls.get('Language').data == 'es' ? window.open(process.env.VUE_APP_POLICIES, '_blank') : window.open(process.env.VUE_APP_POLICIESEN, '_blank'));
    },
    goReservationForm() {
      this.$store.commit('changePersistRegistryData', false)
      this.$router.push({ name: 'ReservacionesRegistro' })
    },
    resetVaucher() {
      this.vaucher.folio = ''
    },
    resetTarjeta() {
      this.credito.tarjetaSeleccionada = ''
      this.credito.numero = ''
      this.credito.tipoDeMascara = ''
      this.credito.nombre = ''
      this.credito.expiracion = ''
      this.fechaExpiracionTarCred = ''
    },
    resetToken() {
      this.token.tarjetaSeleccionada = ''
      this.token.numero = ''
      this.token.nombre = ''
      this.token.expiracion = ''
      this.fechaExpiracionToken = ''
    },
    resetCredito() {
      this.creditoEmpresa.folio = ''
    },
    sendVoucher() {
      this.isVoucherPayment = true

      this.isCreditCardPayment = false

      this.isTokenPayment = false

      this.isTimeLimitPayment = false

      this.isCreditPayment = false
    },
    sendCreditCard() {
      this.isVoucherPayment = false

      this.isCreditCardPayment = true

      this.isTokenPayment = false

      this.isTimeLimitPayment = false

      this.isCreditPayment = false
    },
    sendToken() {
      this.isVoucherPayment = false

      this.isCreditCardPayment = false

      this.isTokenPayment = true

      this.isTimeLimitPayment = false

      this.isCreditPayment = false
    },
    sendTimeLimit() {
      this.isVoucherPayment = true

      this.isCreditCardPayment = false

      this.isTokenPayment = false

      this.isTimeLimitPayment = true

      this.isCreditPayment = false
    },
    sendCreditPay() {
      this.isVoucherPayment = true

      this.isCreditCardPayment = false

      this.isTokenPayment = false

      this.isTimeLimitPayment = false

      this.isCreditPayment = true
    },
    goReservacionesConfirmacion() {
      // Copy
      this.banTitleBusquedaTarifa = true
      if (this.isVoucherPayment) {
        var metodosPagoData = {
          voucherFolio: this.vaucher.folio,
          politicaSeleccionada: this.vaucher.politicaSeleccionada,
          razonSeleccionada: this.vaucher.razonSeleccionada,
          metodoPago: "Voucher",
          businessRa: this.businessRa,
          isCreditCard: 0
        }
        for (var i = 0; i < this.credito.politicas.length; i++) {
          if (metodosPagoData.politicaSeleccionada == this.credito.politicas[i].nombre) {
            metodosPagoData.policieId = this.credito.politicas[i].code
          }
        }


      } if (this.isCreditCardPayment) {


        var metodosPagoData = {

          creditoTarjetaSeleccionada: this.credito.tarjetaSeleccionada,
          creditoTipoDeMascara: this.credito.tipoDeMascara,
          creditoNombre: this.credito.nombre,
          creditoExpiracion: this.credito.expiracion,
          politicaSeleccionada: this.credito.politicaSeleccionada,
          razonSeleccionada: this.credito.razonSeleccionada,
          metodoPago: "Tarjeta de Crédito",
          isCreditCard: 1,
          businessRa: this.businessRa,

          creditCardType: this.cardTypeForService


        }

        for (var i = 0; i < this.credito.politicas.length; i++) {
          if (metodosPagoData.politicaSeleccionada == this.credito.politicas[i].nombre) {
            metodosPagoData.policieId = this.credito.politicas[i].code
          }
        }


      } if (this.isTokenPayment) {


        var metodosPagoData = {


          creditoTarjetaSeleccionada: this.token.tarjetaSeleccionada,
          creditoTipoDeMascara: this.token.numero,
          creditoNombre: this.token.nombre,
          creditoExpiracion: this.token.expiracion,
          creditoPoliticaSeleccionada: this.token.politicaSeleccionada,
          razonSeleccionada: this.token.razonSeleccionada,
          businessRa: this.businessRa,


          metodoPago: "Token",
          isCreditCard: 1,
          creditCardType: this.tokenCreditCardType



        }


        for (var i = 0; i < this.credito.politicas.length; i++) {
          if (metodosPagoData.creditoPoliticaSeleccionada == this.credito.politicas[i].nombre) {
            metodosPagoData.policieId = this.credito.politicas[i].code
          }
        }


      } if (this.isTimeLimitPayment) {


        var metodosPagoData = {


          politicaSeleccionada: this.tiempoLimite.politicaSeleccionada,
          razonSeleccionada: this.tiempoLimite.razonSeleccionada,
          metodoPago: "Tiempo límite",
          businessRa: this.businessRa,

          isCreditCard: 0



        }

        for (var i = 0; i < this.credito.politicas.length; i++) {
          if (metodosPagoData.politicaSeleccionada == this.credito.politicas[i].nombre) {
            metodosPagoData.policieId = this.credito.politicas[i].code
          }
        }
      } if (this.isCreditPayment) {


        var metodosPagoData = {

          creditoEmpresaFolio: this.creditoEmpresa.folio,
          politicaSeleccionada: this.creditoEmpresa.politicaSeleccionada,
          razonSeleccionada: this.creditoEmpresa.razonSeleccionada,
          metodoPago: "Credito",
          businessRa: this.businessRa,

          isCreditCard: 0


        }

        for (var i = 0; i < this.credito.politicas.length; i++) {
          if (metodosPagoData.politicaSeleccionada == this.credito.politicas[i].nombre) {
            metodosPagoData.policieId = this.credito.politicas[i].code
          }
        }

      }


      // Here I must add socialReason
      for (var i = 0; i < this.credito.razones.length; i++) {
        if (this.credito.razones[i].nombre == metodosPagoData.razonSeleccionada) {
          metodosPagoData.agencyKey = this.credito.razones[i].code
          metodosPagoData.agencyAddress = this.credito.razones[i].agencyAddress
          metodosPagoData.agencyPhone = this.credito.razones[i].agencyPhone
          metodosPagoData.agencyRFC = this.credito.razones[i].agencyRFC
          metodosPagoData.agencyType = this.credito.razones[i].agencyType
        }
      }

      //    this.findPaymentMethod

      if (metodosPagoData.metodoPago == 'Voucher') {
        metodosPagoData.paymentMethodForReservationRequest = 'VO'
      }

      if (metodosPagoData.metodoPago == 'Tarjeta de Crédito') {
        metodosPagoData.paymentMethodForReservationRequest = 'CC'
      }
      if (metodosPagoData.metodoPago == 'Token') {
        metodosPagoData.paymentMethodForReservationRequest = 'TK'
      }

      if (metodosPagoData.metodoPago == 'Credito') {
        metodosPagoData.paymentMethodForReservationRequest = 'CXC'
      }

      //  Starting limit time for reservation request
      if (metodosPagoData.metodoPago == 'Tiempo límite') {
        metodosPagoData.paymentMethodForReservationRequest = 'DP'
      }





      var ls = new SecureLS({ encodingType: 'aes' });
      ls.set('metodosPagoData', { data: metodosPagoData })

      //  RESERVATION WS
      var a = ''
      a = ls.get('Token')
      var token = a.data.substr(1);
      var language = ls.get('Language').data;
      if (ls.get('contactDataH1').checkIn == null) {
        var arriveTime = '12:00'
      } else {

        var arriveTime = ls.get('contactDataH1').checkIn;
      }

      var checkInDate = ls.get('availibilityRequest').data.beautiDateInput;
      var checkOutDate = ls.get('availibilityRequest').data.beautiDateOutput;
      var contractCode = ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.contractCode;
      var contractType = ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.contractType;

      var creditCardRequest = ls.get('metodosPagoData').data;
      if (ls.get('metodosPagoData').data.creditoExpiracion == null) {

      } else {
        var expirationMonth = creditCardRequest.creditoExpiracion.substring(0, 2);
        var expirationYear = creditCardRequest.creditoExpiracion.substring(2);
      }


      var currencyCode = ls.get('availibilityRequest').data.currencyCode;
      var acompananteEmail = ls.get('CompanyDataH1').email;

      var acompananteFirstName = ls.get('CompanyDataH1').name;
      var acompananteLastName = ls.get('CompanyDataH1').lastName;
      var acompananteMaternalLastName = ls.get('CompanyDataH1').secondLastName;
      var email = ls.get('contactDataH1').email;
      var firstName = ls.get('dataPersonalH1').simpleName;
      var guardar = ls.get('contactDataH1').saveNewProfileH1;
      var guestProfileId = ls.get('dataPersonalH1').guestProfileId;
      var middleName = ls.get('dataPersonalH1').middleNameForService;
      var lastName = ls.get('dataPersonalH1').fatherSurname;
      var secondLastName = ls.get('dataPersonalH1').motherSurname;
      var title = ls.get('dataPersonalH1').givenName;
      var discountCode = ls.get('availibilityRequest').data.discountCode;
      var hotelCode = ls.get('availibilityRequest').data.hotelCode;
      var iata = ls.get('availibilityRequest').data.iataCode;
      var isCreditCard = ls.get('metodosPagoData').data.isCreditCard;

      if (ls.get('contactDataH1').checkOut == null) {
        var leaveTime = '03:00'
      } else {
        var leaveTime = ls.get('contactDataH1').checkOut;

      }

      var marca = ls.get('brandCodeForReservationService').data;
      var nights = ls.get('updateCostDetail').data.hotel.nights;
      var numberAdults = ls.get('updateCostDetail').data.habitacion.totalAdults;
      var numberChildren = ls.get('updateCostDetail').data.habitacion.totalChildren;

      var numberRooms = ls.get('updateCostDetail').data.habitacion.totalRooms;
      var pif = ls.get('availibilityRequest').data.motivaCode;

      if (ls.get('updateCostDetail').data.hotel.benefitsRestrictions == null || ls.get('updateCostDetail').data.hotel.benefitsRestrictions.rateDescription == null) {
        var rateDescription = ''
        var briefDescription = ''
        var benefitsFWS = ''
        var restrictionsFWS = ''


      } else {
        var briefDescription = String(ls.get('updateCostDetail').data.hotel.benefitsRestrictions.rateName)
        var rateDescription = ls.get('updateCostDetail').data.hotel.benefitsRestrictions.rateDescription;
        var benefitsFWS = String(ls.get('updateCostDetail').data.hotel.benefitsRestrictions.benefits)
        var restrictionsFWS = String(ls.get('updateCostDetail').data.hotel.benefitsRestrictions.restrictions)
      }
      var amenityList = ls.get('DetailHotelInfo').data.response.amenityList

      var benefitsAndRestrictions = benefitsFWS.concat(restrictionsFWS)

      var sendValidatedProformGranted = false
      if (ls.get('sendProformH1').sendProformH1 == null) {
        sendValidatedProformGranted = false
      } else {
        sendValidatedProformGranted = ls.get('sendProformH1').sendProformH1
      }
      //  ADJUSTING DATE

      if (ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].rateMandatorySupplementResponseList === null || ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].rateMandatorySupplementResponseList.length === 0) {
        var findingDate = '11/11/2019'
      } else {
        var findingDate = String(ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].rateMandatorySupplementResponseList[0].date);
      }
      var newDate = findingDate.split("/").reverse().join("-");
      var fixFormat = "T00:00:00.000";
      var realDate = newDate.concat(fixFormat);
      // END OF ADJUSTMENT

      // DELETING JUST ENOUGH RUBBISH

      if (String(ls.get('metodosPagoData').data.paymentMethodForReservationRequest) == 'DP') {

        var cardHoldersName2 = ""
        var expirationMonth2 = ""
        var expirationYear2 = ""
        var paymentCardType2 = ""
        var token2 = ""

      } else {

        var cardHoldersName2 = String(creditCardRequest.creditoNombre)
        var expirationMonth2 = String(expirationMonth)
        var expirationYear2 = String(expirationYear)
        var paymentCardType2 = String(creditCardRequest.creditCardType)
        var token2 = String(creditCardRequest.creditoTipoDeMascara)
      }
      if (ls.get('contactDataH1').address == null || ls.get('contactDataH1').address == undefined || ls.get('contactDataH1').address == '') {
        var addressType = 'MOB'
      } else {

        var addressType = String(ls.get('contactDataH1').address)
      }

      if (ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].commissionResponse == null) {
        var contract2 = ''
        var baseAmount2 = ''
        var commissionAmount2 = ''
        var commissionPercentage2 = ''

      } else {
        var contract2 = ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].commissionResponse.contract
        var baseAmount2 = ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].commissionResponse.baseAmount
        var commissionAmount2 = ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].commissionResponse.commissionAmount
        var commissionPercentage2 = ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].commissionResponse.commissionPercentage

      }

      //KB47296 Start
      if (ls.get('contactDataH1').phoneNumber == null || ls.get('contactDataH1').phoneNumber == "") {

        var jobPhoneNumber22 = "          "
        var jobAreaCode22 = "          ";
      } else {
        const phoneNumberLength = ls.get('contactDataH1').phoneNumber.length;
        var jobPhoneNumber22 = ls.get('contactDataH1').phoneNumber.substr( phoneNumberLength - 10, phoneNumberLength );
        const auxPhoneNumber = jobPhoneNumber22.substr( phoneNumberLength - 10, phoneNumberLength );
        if(ls.get('contactDataH1').areaCode === "+52" && ls.get('contactDataH1').telephoneType === "MOB"){
          var jobAreaCode22 ="+521"
         }else{
          var jobAreaCode22 =ls.get('contactDataH1').areaCode;
         }
        //Start 49294
         if(jobAreaCode22.charAt(0) == "+"){
            const str = jobAreaCode22.slice(1);
            jobAreaCode22= str;
         }
        //End 49294
        if(jobPhoneNumber22.length < 10) {
          jobPhoneNumber22.concat("            ")
          jobPhoneNumber22 = jobPhoneNumber22.substring(0, 10);
        } else if (jobPhoneNumber22.length > 10) {
          jobPhoneNumber22 = jobPhoneNumber22.substring(0, 10);
        }

      }
     

      //KB47296 End
      if (ls.get('metodosPagoData').data.policieId == null) {
        var policieId22 = ""
      } else {
        var policieId22 = String(ls.get('metodosPagoData').data.policieId)
      }
      if (ls.get('metodosPagoData').data.agencyKey == null) {
        var razonKey = '';
      } else {
        var razonKey = String(ls.get('metodosPagoData').data.agencyKey);
      }

      if (String(ls.get('Profile').data.parentUsername) == "null" || String(ls.get('Profile').data.parentUsername) == "undefined") {
        var parendId22 = ''
      } else {
        var parendId22 = String(ls.get('Profile').data.parentUsername)
      }
      if (String(acompananteEmail) == "undefined") {
        var kotoba1 = ""
      } else {
        var kotoba1 = String(acompananteEmail)
      }
      if (String(acompananteFirstName) == "undefined") {
        var kotoba2 = ""
      } else {
        var kotoba2 = String(acompananteFirstName)
      }
      if (String(acompananteLastName) == "undefined") {
        var kotoba3 = ""
      } else {
        var kotoba3 = String(acompananteLastName)
      }
      if (String(acompananteMaternalLastName) == "undefined") {
        var kotoba4 = ""
      } else {
        var kotoba4 = String(acompananteMaternalLastName)
      }
      if (ls.get('Profile').data.email == "reservacionescorporate@posadas.com") {
        var emailProfile = ""

      } else {
        var emailProfile = ls.get('Profile').data.email
      }

      //Preferences 1
      var totalPreferences = this.validadorPreferenciasVacias(1);

      //Preferences 2
      var totalPreferences2 = this.validadorPreferenciasVacias(2);

      //Preferences 3
      var totalPreferences3 = this.validadorPreferenciasVacias(3);

      //Preferences 4
      var totalPreferences4 = this.validadorPreferenciasVacias(4);

      //Preferences 5
      var totalPreferences5 = this.validadorPreferenciasVacias(5);

      var showPR = ((this.tipoClienteID == this.pyp || this.tipoClienteID == this.pypsa) && this.tipoTarifa == 1 ? false : this.ls.get('Profile').data.ratesPermissionsResponse.showPublicRates)
      var showR = ((this.tipoClienteID == this.pyp || this.tipoClienteID == this.pypsa) && this.tipoTarifa == 1 ? false : this.ls.get('Profile').data.ratesPermissionsResponse.showRates)

      // Filling up my profileRequest
      var profileRequest22 = []
      profileRequest22.push({
        acompananteEmail: kotoba1,
        acompananteFirstName: kotoba2.toUpperCase(),
        acompananteLastName: kotoba3.toUpperCase(),
        acompananteMaternalLastName: kotoba4.toUpperCase(),
        address: String(ls.get('contactDataH1').streetNumber),
        address2: String(ls.get('contactDataH1').town),
        addressType: addressType,
        codigoPostal: String(ls.get('contactDataH1').postCode),
        costCenter: String(ls.get('dataPersonalH1').costCenter),
        country: String(ls.get('contactDataH1').countryCode),
        emailProfile: emailProfile,
        email: String(ls.get('contactDataH1').email),
        emailAlter: String(ls.get('contactDataH1').emailAlter),
        excellencePin: String(ls.get('dataPersonalH1').apreciation),
        fiestaRewardsNumber: String(ls.get('dataPersonalH1').rewardsNumber),
        firstName: String(firstName).toUpperCase(),
        guardar: ls.get('contactDataH1').saveNewProfileH1,
        guestProfileId: String(guestProfileId),
        jobPhoneExt: "52",
        jobAreaCode:jobAreaCode22,
        jobPhoneNumber: jobPhoneNumber22,
        lastName: String(ls.get('dataPersonalH1').fatherSurname).toUpperCase(),
        middleName: String(ls.get('dataPersonalH1').middleNameForService).toUpperCase(),
        numberEmpl: String(ls.get('dataPersonalH1').agentNumber),
        parendId: parendId22,
        preferencias: totalPreferences,
        preferenciasTexto: ls.get('requirementsDataH1').preferenciasTexto,
        profileId: String(ls.get('Profile').data.profileId),
        profileType: String(ls.get('Profile').data.profileType),
        secondLastName: String(ls.get('dataPersonalH1').motherSurname).toUpperCase(),
        showPublicRates: showPR,
        showRates: showR,
        state: String(ls.get('contactDataH1').stateCode),
        suplementos: "",
        suplements: [

        ],
        telephoneType: String(ls.get('contactDataH1').telephoneType),
        userId: String(ls.get('userIdForReservationRequest').data)
      })
      if (ls.get('dataPersonalH2').nombres == null) {

      } else {
        profileRequest22.push({

          acompananteEmail: "",
          acompananteFirstName: "",
          acompananteLastName: "",
          acompananteMaternalLastName: "",
          address: String(ls.get('contactDataH1').streetNumber),
          address2: String(ls.get('contactDataH1').town),
          addressType: addressType,
          codigoPostal: String(ls.get('contactDataH1').postCode),
          costCenter: "",
          country: String(ls.get('contactDataH1').countryCode),
          emailProfile: "",
          email: String(ls.get('contactDataH2').email),
          emailAlter: "",
          excellencePin: String(ls.get('dataPersonalH1').apreciation),
          fiestaRewardsNumber: String(ls.get('dataPersonalH1').rewardsNumber),
          firstName: ls.get('dataPersonalH2').nombres.toUpperCase(),
          guardar: ls.get('contactDataH2').saveNewProfileH2,
          guestProfileId: "",
          jobPhoneExt: "",
          jobPhoneNumber: "",
          jobAreaCode:"",
          lastName: ls.get('dataPersonalH2').apellidoP.toUpperCase(),
          middleName: ls.get('dataPersonalH2').middleNameForService.toUpperCase(),
          numberEmpl: "",
          parendId: parendId22,
          preferencias: totalPreferences2,
          preferenciasTexto: ls.get('requirementsDataH2').preferenciasTexto,

          profileId: String(ls.get('Profile').data.profileId),
          profileType: String(ls.get('Profile').data.profileType),
          secondLastName: ls.get('dataPersonalH2').apellidoM.toUpperCase(),
          showPublicRates: showPR,
          showRates: showR,
          state: String(ls.get('contactDataH1').stateCode),
          suplementos: "",
          suplements: [],
          telephoneType: "",
          userId: String(ls.get('userIdForReservationRequest').data)
        })
      }

      if (ls.get('dataPersonalH3').nombres == null) {

      } else {
        profileRequest22.push({
          acompananteEmail: "",
          acompananteFirstName: "",
          acompananteLastName: "",
          acompananteMaternalLastName: "",
          address: String(ls.get('contactDataH1').streetNumber),
          address2: String(ls.get('contactDataH1').town),
          addressType: addressType,
          codigoPostal: String(ls.get('contactDataH1').postCode),
          costCenter: "",
          country: String(ls.get('contactDataH1').countryCode),
          emailProfile: "",

          email: String(ls.get('contactDataH3').email),
          emailAlter: "",
          excellencePin: String(ls.get('dataPersonalH1').apreciation),
          fiestaRewardsNumber: String(ls.get('dataPersonalH1').rewardsNumber),
          firstName: ls.get('dataPersonalH3').nombres.toUpperCase(),
          guardar: ls.get('contactDataH3').saveNewProfileH3,
          guestProfileId: "",
          jobPhoneExt: "",
          jobPhoneNumber: "",
          jobAreaCode:"",
          lastName: ls.get('dataPersonalH3').apellidoP.toUpperCase(),
          middleName: ls.get('dataPersonalH3').middleNameForService.toUpperCase(),
          numberEmpl: "",
          parendId: parendId22,
          preferencias: totalPreferences3,
          preferenciasTexto: ls.get('requirementsDataH3').preferenciasTexto,

          profileId: String(ls.get('Profile').data.profileId),
          profileType: String(ls.get('Profile').data.profileType),
          secondLastName: ls.get('dataPersonalH3').apellidoM.toUpperCase(),
          showPublicRates: showPR,
          showRates: showR,
          state: String(ls.get('contactDataH1').stateCode),
          suplementos: "",
          suplements: [],
          telephoneType: "",
          userId: String(ls.get('userIdForReservationRequest').data)
        })

      }

      if (ls.get('dataPersonalH4').nombres == null) {

      } else {
        profileRequest22.push({

          acompananteEmail: "",
          acompananteFirstName: "",
          acompananteLastName: "",
          acompananteMaternalLastName: "",
          address: String(ls.get('contactDataH1').streetNumber),
          address2: String(ls.get('contactDataH1').town),
          addressType: addressType,
          codigoPostal: String(ls.get('contactDataH1').postCode),
          costCenter: "",
          country: String(ls.get('contactDataH1').countryCode),
          emailProfile: "",

          email: String(ls.get('contactDataH4').email),
          emailAlter: "",
          excellencePin: String(ls.get('dataPersonalH1').apreciation),
          fiestaRewardsNumber: String(ls.get('dataPersonalH1').rewardsNumber),
          firstName: ls.get('dataPersonalH4').nombres.toUpperCase(),
          guardar: ls.get('contactDataH4').saveNewProfileH4,
          guestProfileId: "",
          jobPhoneExt: "",
          jobPhoneNumber: "",
          jobAreaCode:"",
          lastName: ls.get('dataPersonalH4').apellidoP.toUpperCase(),
          middleName: ls.get('dataPersonalH4').middleNameForService.toUpperCase(),
          numberEmpl: "",
          parendId: parendId22,
          preferencias: totalPreferences4,
          preferenciasTexto: ls.get('requirementsDataH4').preferenciasTexto,

          profileId: String(ls.get('Profile').data.profileId),
          profileType: String(ls.get('Profile').data.profileType),
          secondLastName: ls.get('dataPersonalH4').apellidoM.toUpperCase(),
          showPublicRates: showPR,
          showRates: showR,
          state: String(ls.get('contactDataH1').stateCode),
          suplementos: "",
          suplements: [],
          telephoneType: "",
          userId: String(ls.get('userIdForReservationRequest').data)
        })
      }

      if (ls.get('dataPersonalH5').nombres == null) {

      } else {


        profileRequest22.push({

          acompananteEmail: "",
          acompananteFirstName: "",
          acompananteLastName: "",
          acompananteMaternalLastName: "",
          address: String(ls.get('contactDataH1').streetNumber),
          address2: String(ls.get('contactDataH1').town),
          addressType: addressType,
          codigoPostal: String(ls.get('contactDataH1').postCode),
          costCenter: "",
          country: String(ls.get('contactDataH1').countryCode),
          emailProfile: "",

          email: String(ls.get('contactDataH5').email),
          emailAlter: "",
          excellencePin: String(ls.get('dataPersonalH1').apreciation),
          fiestaRewardsNumber: String(ls.get('dataPersonalH1').rewardsNumber),
          firstName: ls.get('dataPersonalH5').nombres.toUpperCase(),
          guardar: ls.get('contactDataH5').saveNewProfileH5,
          guestProfileId: "",
          jobPhoneExt: "",
          jobPhoneNumber: "",
          jobAreaCode:"",
          lastName: ls.get('dataPersonalH5').apellidoP.toUpperCase(),
          middleName: ls.get('dataPersonalH5').middleNameForService.toUpperCase(),
          numberEmpl: "",
          parendId: parendId22,
          preferencias: totalPreferences5,
          preferenciasTexto: ls.get('requirementsDataH5').preferenciasTexto,

          profileId: String(ls.get('Profile').data.profileId),
          profileType: String(ls.get('Profile').data.profileType),
          secondLastName: ls.get('dataPersonalH5').apellidoM.toUpperCase(),
          showPublicRates: showPR,
          showRates: showR,
          state: String(ls.get('contactDataH1').stateCode),
          suplementos: "",
          suplements: [],
          telephoneType: "",
          userId: String(ls.get('userIdForReservationRequest').data)

        })


      }
      // Filling up my profileRequest
      if (ls.get('DetailHotelInfo').data.response.hotelPhone == null || ls.get('DetailHotelInfo').data.response == null || ls.get('DetailHotelInfo').data == null) {
        var telephone22 = ''
      } else {
        var telephone22 = String(ls.get('DetailHotelInfo').data.response.hotelPhone)
      }
      if (cardHoldersName2 == "undefined") {
        cardHoldersName2 = ""
      }
      if (expirationMonth2 == "undefined") {
        expirationMonth2 = ""
      }
      if (token2 == "undefined") {
        token2 = ""
      }
      if (paymentCardType2 == "undefined") {
        paymentCardType2 = ""
      }
      if (expirationYear2 == "undefined") {
        expirationYear2 = ""
      }
      if (ls.get('supplement').data.supplementMandatoryResponseList == null) {
        var totalQuantity22 = ''
      } else {
        if (ls.get('supplement').data.supplementMandatoryResponseList.length == 0) {
          var totalQuantity22 = ""
        } else {
          var totalQuantity22 = ls.get('supplement').data.supplementMandatoryResponseList[0].totalQuantity
        }
      }
      var anotherArray = []
      if (ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses == null) {
        for (var r = 0; r < ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses.length; r++) {
          anotherArray.push(ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[r].freeNight)
        }
      }
      var ratesDetailResponseListFWS = ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses

      for (var rr = 0; rr < ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses.length; rr++) {
        delete ratesDetailResponseListFWS[rr].freeNights
        if (ratesDetailResponseListFWS[rr].rateMandatorySupplementResponseList != null) {
          if (ratesDetailResponseListFWS[rr].rateMandatorySupplementResponseList.length != 0) {
            var newDate2 = ratesDetailResponseListFWS[rr].rateMandatorySupplementResponseList[0].date.split("/").reverse().join("-");
            var fixFormat2 = "T00:00:00.000";
            ratesDetailResponseListFWS[rr].rateMandatorySupplementResponseList[0].date = newDate2.concat(fixFormat2);

          } else {
            ratesDetailResponseListFWS[rr].rateMandatorySupplementResponseList = []
          }
        }
      }
      // Fin de beacoup de nuits
      if (ls.get('requirementsDataH1').preferenciasTexto == null) {
        var preferenciasTexto22 = ''

      } else {
        var preferenciasTexto22 = ls.get('requirementsDataH1').preferenciasTexto
      }
      if (ls.get('moreStayingTaxes') == null || ls.get('moreStayingTaxes') == '') {
        var moreStayingTaxes = 0
      } else {
        var moreStayingTaxes = ls.get('moreStayingTaxes')
      }
      if (ls.get('moreStayingTaxesMinor') == '' || ls.get('moreStayingTaxesMinor') == null) {
        var moreStayingTaxesMinor = 0
      } else {
        var moreStayingTaxesMinor = ls.get('moreStayingTaxesMinor')

      }
      var totalCost2 = ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.totalRateWithTaxesByRoom + moreStayingTaxes
      this.totalCost2S = totalCost2
      var totalTaxes2 = ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.totalTaxes + moreStayingTaxesMinor
      if (ls.get('rateNameDiscountCode') == null || ls.get('rateNameDiscountCode') == "") {
      } else {
        briefDescription = ls.get('rateNameDiscountCode')
      }

      // Set roomName
      var nouvelleChambre = ""
      if (ls.get('roomNameSW') != null && ls.get('allowF')) {
        nouvelleChambre = this.ls.get('roomNameSW')
      } else {
        nouvelleChambre = ls.get('datosHabHotSelected').data.hotel.title

      }
      // Set roomName
      var specialMessage = '';
      if (ls.get('datosHabHotSelected').data.specialMessage.length === 0 || ls.get('datosHabHotSelected').data.specialMessage === null || ls.get('datosHabHotSelected').data.specialMessage === undefined) {
        specialMessage = false;
      } else {
        specialMessage = true;
      }

      var vaoucherOrCredEmpresa = (this.iconoActivo === 0 ? this.vaucher.folio : this.iconoActivo === 4 ? this.creditoEmpresa.folio : '')

      var reservationRequest = {
        creditCard: {
          cardHoldersName: cardHoldersName2.toUpperCase(),
          expirationMonth: expirationMonth2,
          expirationYear: expirationYear2.replace('/', ''),
          paymentCardType: paymentCardType2,
          token: token2,
          cardValidation: 'true',
          tokenAction: this.saveOrUpdate
        },
        datos: {
          amenityList: amenityList,
          arriveTime: String(arriveTime),
          beneficios: benefitsFWS,
          briefDescription: briefDescription,
          centralId: "",
          checkInDate: String(checkInDate),
          checkOutDate: String(checkOutDate),
          commentType: "GRL",
          confirmationInfants: "Infantes",
          contractCode: String(contractCode),
          contractType: String(contractType),
          cuponCXC: vaoucherOrCredEmpresa,
          cuponCxCDesc: "",
          currencyCode: String(currencyCode),
          descuento: String(discountCode),
          iata: iata + '',
          infants: String(ls.get('updateCostDetail').data.habitacion.totalInfants),
          language: this.$store.getters.gettinglang,
          leaveTime: leaveTime,
          nights: nights,
          numberAdults: String(numberAdults),
          numberChildren: String(numberChildren),
          numberRooms: numberRooms,
          paymentMethod: String(ls.get('metodosPagoData').data.paymentMethodForReservationRequest),
          paymentType: "0",
          pif: String(pif),
          policieId: (policieId22 === '-1' ? '' : policieId22),
          policieText: String(rateDescription),
          promoCode: String(ls.get('availibilityRequest').data.promoCode),
          reservDetailVOConfirm: "",
          restricciones: restrictionsFWS,
          sendCopyTo: String(ls.get('contactDataH1').emailAlter),
          sendProformGranted: sendValidatedProformGranted,
          tradeName: (razonKey === '-1' ? '' : razonKey),
          yieldType: String(ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.yieldType),
          sendSpecialConsiderations: specialMessage
        },
        hotel: {
          brandCode: String(ls.get('brandCodeForWs').data),
          brandImage: String(ls.get('DetailHotelInfo').data.response.brandImage),
          brandName: String(ls.get('brandNameForWs').data),
          hotelAddress: String(ls.get('DetailHotelInfo').data.response.hotelAddress),
          hotelCode: String(hotelCode),
          hotelFax: String(ls.get('DetailHotelInfo').data.response.hotelFax),
          hotelImage: String(ls.get('hotelMailImage').data),
          hotelName: String(ls.get('DetailHotelInfo').data.response.hotelName),
          hotelPhone: telephone22,
          hotelurl: "",
          roomCode: String(ls.get('updateCostDetail').data.hotel.roomCode),
          roomImage: String(ls.get('datosHabHotSelected').data.hotel.img),

          roomName: String(nouvelleChambre),
        },
        isCreditCard: String(isCreditCard),
        profile: profileRequest22,
        profileIdUser: ls.get('dataPersonalH1').guestProfileId,
        userId: String(ls.get('userIdForReservationRequest').data),
        profileId: String(ls.get('Profile').data.profileId),
        rates: {
          quantity: totalQuantity22,
          averageCostPerNight: ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.averageRatePerNight,
          ratesDetailResponseList: ratesDetailResponseListFWS,
          totalCost: totalCost2,
          totalCostWithTaxes: ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.totalRateWithTaxesByRoom,
          totalCostWithoutTaxes: ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.totalRateWithoutTaxes,
          totalSupplements: ls.get('totalSupplements'),
          supplementTotalTaxes: ls.get('totalSupplementsTax'),
          totalTaxes: totalTaxes2
        },
        codigoFiestaReward : (ls.get('dataPersonalH1').codigoFiestaReward),

      }
      reservationRequest.datos.language = ls.get('Language').data
      if (ls.get('supplement').data.supplementMandatoryResponseList.length == 0) {
        delete reservationRequest.rates.quantity
      } else {

      }
      var test = { 'red': '#FF0000', 'blue': '#0000FF' };
      delete test.blue; // or use => delete test['blue'];

      if (reservationRequest.datos.descuento == "undefined") {
        reservationRequest.datos.descuento = ""
      }

      if (reservationRequest.datos.iata == "undefined") {
        reservationRequest.datos.iata = ""
      }

      ls.remove('dataPersonalH2')
      ls.remove('dataPersonalH3')
      ls.remove('dataPersonalH4')
      ls.remove('dataPersonalH5')
      var updNeg = []
      // Second chambre
      const datosHHS = this.ls.get('datosHabHotSelected');
      for (var i = 0; i < reservationRequest.profile.length; i++) {
        reservationRequest.profile[i].profileId = []
        reservationRequest.profile[i].profileId.push(String(ls.get('Profile').data.profileId))
        if (reservationRequest.datos.descuento != '') {
          reservationRequest.profile[i].profileId.push(reservationRequest.datos.descuento)
        }
        var a = reservationRequest.profile[i].profileId.filter(function (item, pos) {
          return reservationRequest.profile[i].profileId.indexOf(item) == pos;
        })
        reservationRequest.profile[i].profileId = a

      }
      // Troisieme chambre
      if (this.ls.get('opSuE') != null && this.ls.get('opSuE') != "") {
        reservationRequest.rateOptionalSupplementResponseList = this.ls.get('opSuE')

      } else {
        reservationRequest.rateOptionalSupplementResponseList = []

      }

      // Quatrieme chambre

      // Cinquieme chambre

      axios.post(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_RESERVATION, reservationRequest
        , {
          withCredentials: true,
          credentials: 'include',
          headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json',
            'Accept-Language': language
          }
        })

        .then(res => {


          if ((res.status == 200 || res.status == 201) && res.data.code == "RSP_HOTEL_RESERV_00") {

            var ls = new SecureLS({ encodingType: 'aes' });
            ls.set('responseReservation', { data: res.data.response })
            this.banTitleBusquedaTarifa = false
            profileRequest22 = []

            if (reservationRequest.datos.currencyCode == "MXN" && this.$store.getters.gettingLang == "en") {
              var d1 = reservationRequest.datos.checkInDate.replace(/^(\d{1,2}\/)(\d{1,2}\/)(\d{4})$/, "$2$1$3");
              var d2 = reservationRequest.datos.checkOutDate.replace(/^(\d{1,2}\/)(\d{1,2}\/)(\d{4})$/, "$2$1$3");
              var updatedates = this.ls.get('datosHabHotSelected').data
              updatedates.habitacion.beautiDateInput = d1
              updatedates.habitacion.beautiDateOutput = d2
              this.ls.set('datosHabHotSelected', { data: updatedates })

            }

            if (reservationRequest.datos.currencyCode == "USD" && this.$store.getters.gettingLang == "es") {
              var d1 = reservationRequest.datos.checkInDate.replace(/^(\d{1,2}\/)(\d{1,2}\/)(\d{4})$/, "$2$1$3");
              var d2 = reservationRequest.datos.checkOutDate.replace(/^(\d{1,2}\/)(\d{1,2}\/)(\d{4})$/, "$2$1$3");
              var updatedates = this.ls.get('datosHabHotSelected').data
              updatedates.habitacion.beautiDateInput = d1
              updatedates.habitacion.beautiDateOutput = d2
              this.ls.set('datosHabHotSelected', { data: updatedates })

            }
            var updatedates2 = this.ls.get('datosHabHotSelected').data
            updatedates2.hotel.negotiatedRatesDetailPrice.totalRateWithTaxes = this.totalCost2S
            this.ls.set('datosHabHotSelected', { data: updatedates2 })


            this.$router.push({ name: 'ReservacionesConfirmacion' })

          }


          if (((res.status == 200 || res.status == 201) && res.data.code == "RSP_HOTEL_RESERV_00") && (res.data.response[0].numReservation == 0 || res.data.response[0].numReservation == "0" || res.data.response[0].numReservation == null || res.data.response[0].numReservation == [])) {

            this.pasConfirmation2 = true
          }

          if (res.status == 401) {
            this.banTitleBusquedaTarifa = false
            profileRequest22 = []
            this.clearLocalStorage()
          }

        })
        .catch(error => {
          let errorObject = JSON.parse(JSON.stringify(error));
          profileRequest22 = []

          if (error.response.data.errorCode == 'RSP_HOTEL_AVAIL_06' || error.response.data.errorCode == 'RSP_HOTEL_AVAIL_07') {
            GlobalFunctions.cleanLocalStorageOfReserva();
            this.banError6 = true;
            this.error6Body = error.response.data.message;
          } else {
            if (error.response.status == 404 && error.response.data.errorCode == 'RSP_RESERV_SEARCH_CODE_03') {
              this.pasConfirmation = true
              this.pasConfirmationBody = error.response.data.message;
              this.enableLoader = false
            } else {
              if (errorObject.message == 'Network Error' || (error.response.status < 600 && error.response.status > 403) || (error.response.status < 399 && error.response.status > 299) || error.response.status < 200) {
                this.$router.push({ name: "Error" });
              }
            }
          }
        })

      //  END RESERVATION WS


    },
    closeExpiredModal() {
      this.isExpiredModalVisible = false
      var ls = new SecureLS({ encodingType: 'aes' });
      //ls.clear()
      GlobalFunctions.localStorageClean();
      this.$router.push({ name: 'Login' })
    },
    consultaMetodosPago() {
      const datosHHS = this.ls.get('datosHabHotSelected');
      const userProperties = this.ls.get('userProperties');

      var dataMetPag = {
        hotelCode: null,
        arrivalDate: null,
        departureDate: null,
        currencyCode: null,
        contractCode: null,
        contractType: null,
        agreementCode: null,
        iataCode: null,
        motivaCode: null,
        userProperties: [],
      };

      dataMetPag.agreementCode = datosHHS.data.habitacion.agreementCode;
      dataMetPag.arrivalDate = GlobalFunctions.convertBeautifulDate(datosHHS.data.habitacion.arrivalDate, this.ls.get('Language').data);
      dataMetPag.departureDate = GlobalFunctions.convertBeautifulDate(datosHHS.data.habitacion.departureDate, this.ls.get('Language').data);
      dataMetPag.hotelCode = datosHHS.data.habitacion.hotelCode;
      dataMetPag.currencyCode = datosHHS.data.habitacion.currencyCode;
      dataMetPag.contractCode = datosHHS.data.hotel.negotiatedRatesDetailPrice.contractCode;
      dataMetPag.contractType = datosHHS.data.hotel.negotiatedRatesDetailPrice.contractType;
      dataMetPag.iataCode = datosHHS.data.habitacion.iataCode;
      dataMetPag.motivaCode = datosHHS.data.habitacion.motivaCode;
      var userPropertiesTemp = [];
      for (var usProp of userProperties.data) {
        userPropertiesTemp.push(Number(usProp.propertyId))
      }
      dataMetPag.userProperties = userPropertiesTemp.sort().join();
      GlobalServices._consultaMetodosPagos(dataMetPag, this.ls.get('Token').data, this.ls.get('Language').data).then(responseMetPag => {
        this.findPaymentMethod = responseMetPag.paymentMethodTypeResponseList
        var listTarjTemp = [];
        for (var res of responseMetPag.data.paymentCardTypeResponseList) {
          if (res.paymentCardType.toLowerCase() === 'amexco') {
            listTarjTemp.push({ nombre: res.paymentCardName, tipoT: 1, code: res.paymentCardType });
          }
          if (res.paymentCardType.toLowerCase() === 'diners') {
            listTarjTemp.push({ nombre: res.paymentCardName, tipoT: 2, code: res.paymentCardType });
          }
          if (res.paymentCardType.toLowerCase() === 'master') {
            listTarjTemp.push({ nombre: res.paymentCardName, tipoT: 3, code: res.paymentCardType });
          }
          if (res.paymentCardType.toLowerCase() === 'visa') {
            listTarjTemp.push({ nombre: res.paymentCardName, tipoT: 4, code: res.paymentCardType });
          }
        }
        this.credito.tarjetas = listTarjTemp;
        this.token.tarjetas = listTarjTemp;

        if (responseMetPag.data.paymentMethodTypeResponseList === 0) {
          this.banMetPago.banVaucher = false;
          this.banMetPago.banTarjCred = false;
          this.banMetPago.banToken = false;
          this.banMetPago.banTiemLim = false;
          this.banMetPago.banCredito = false;
        } else {
          for (var res1 of responseMetPag.data.paymentMethodTypeResponseList) {
            if (res1.paymentMethodType.toLowerCase() === 'vo') {
              this.banMetPago.banVaucher = true;
            }
            if (res1.paymentMethodType.toLowerCase() === 'cc') {
              this.banMetPago.banTarjCred = true;
            }
            if (res1.paymentMethodType.toLowerCase() === 'tk') {
              this.banMetPago.banToken = true;
            }
            if (res1.paymentMethodType.toLowerCase() === 'dp') {
              this.banMetPago.banTiemLim = true;
            }
            if (res1.paymentMethodType.toLowerCase() === 'cxc') {
              this.banMetPago.banCredito = true;
            }
          }
        }
      }).catch(error => {
        if (error.message == 'Network Error' || (error.status < 600 && error.status > 403) || (error.status < 399 && error.status > 299) || error.status < 200 || error.status == 0 || (error.status == 404 && error.errorCode == 'RSP_PAYMENT_VALID_01')) {
          this.$router.push({ name: "Error" });
        }
        // Error server 
        if (error.status === 401) {
          this.clearLocalStorage();
        }
      });

    },
    detalleTarifa() {
      /**
       * se baja del localStorage los datos de la habitacion, usuario, tarifa que el usuario selecciono
       * y se manda al componente detalle de la tarifa.
       */
      this.infoReserva = this.ls.get('datosHabHotSelected');
    },
    politicaViajeRazonSocial() {
      const profile = this.ls.get('Profile').data;
      const datosHabHotSelected = this.ls.get('datosHabHotSelected').data;
      var dataPoliticas = {
        userType: profile.userType,
        contractType: datosHabHotSelected.hotel.negotiatedRatesDetailPrice.contractType,
        discountCode: datosHabHotSelected.habitacion.discountCode
      };
      GlobalServices._consultaPoliticasViaje(dataPoliticas, this.ls.get('Token').data, this.ls.get('Language').data).then(reponsePoliticas => {
        var listTemp = [];
        for (let pol of reponsePoliticas.data) {
          listTemp.push({ nombre: pol.policyName, code: pol.policyCode });
        }
        this.vaucher.politicas = listTemp;
        this.credito.politicas = listTemp;
        this.tiempoLimite.politicas = listTemp;
        this.creditoEmpresa.politicas = listTemp;
        this.token.politicas = listTemp;
        this.politicasList = listTemp;
        this.politicaSelectedDefault(listTemp);
      }).catch(error => {
        // Error server
        if ((error.status == 404 && (error.errorCode == "RSP_LIFERAY_PARSE_01" || error.errorCode == "RSP_LIFERAY_PARSE_02")) || error.status == 500 || error.status == 502 || error.status == 503 || error.status == 504) {
          this.$router.push({ name: "Error" });
        }
        // Error server 
        if (error.status === 401) {
          this.clearLocalStorage();
        }
      });

      //Start KB44128 
      var contractTypeProfile = "";
      if (profile.profileId == "POSADAS" ){
        contractTypeProfile= "1";
      }else{
        contractTypeProfile=datosHabHotSelected.hotel.negotiatedRatesDetailPrice.contractType;
      }
      var dataRazones = {
        iata: datosHabHotSelected.habitacion.iataCode,
        agreement: datosHabHotSelected.habitacion.agreementCode,
        discount: datosHabHotSelected.habitacion.discountCode,
        showINT: false,
        contractType: contractTypeProfile
      //End KB44128 
      };
      GlobalServices._consultaRazonesSociales(dataRazones, this.ls.get('Token').data, this.ls.get('Language').data).then(responseRazones => {
        var listTemp = [];
        for (let raz of responseRazones.data) {
          listTemp.push({ razonSe: raz.agencyBusinessName, nombre: raz.agencyName, code: raz.agencyKey, agencyAddress: raz.agencyAddress, agencyPhone: raz.agencyPhone, agencyRFC: raz.agencyRFC, agencyType: raz.agencyType });
        }
        this.vaucher.razones = listTemp;
        this.credito.razones = listTemp;
        this.tiempoLimite.razones = listTemp;
        this.creditoEmpresa.razones = listTemp;
        this.token.razones = listTemp;
        this.razonSelectedDefault(listTemp);
      }).catch(error => {
        // Error server
        if ((error.status == 404 && (error.errorCode == "RSP_LIFERAY_PARSE_01" || error.errorCode == "RSP_LIFERAY_PARSE_02")) || error.status == 500 || error.status == 502 || error.status == 503 || error.status == 504) {
          this.$router.push({ name: "Error" });
        }
        if (error.status === 401) {
          this.clearLocalStorage();
        }
      });
    },
    politicaSelectedDefault(listPoliticas) {
      if (listPoliticas.length > 0) {
        this.politicaSelectedDefault2(listPoliticas);
        for (var list of listPoliticas) {
          if (list.code === '-1') {
            this.banPoliticaSelectedDefault = true;
            this.vaucher.politicaSeleccionada = list.nombre;
            this.vaucher.politicaSeleccionadaCode = '-1';

            this.creditoEmpresa.politicaSeleccionada = list.nombre;
            this.creditoEmpresa.politicaSeleccionadaCode = '-1';

            this.credito.politicaSeleccionada = list.nombre;
            this.tiempoLimite.politicaSeleccionada = list.nombre;
            this.token.politicaSeleccionada = list.nombre;

            this.banSelectedPoliticaVaucher = true;
            this.banSelectedPoliticaCredito = true;
            this.banSelectedPoliticaToken = true;
            this.banSelectedPoliticaCreditoEmpresa = true;
            this.banSelectedPoliticaTiempoLimite = true;
          }
        }
      }
    },
    razonSelectedDefault(listRazones) {
      if (listRazones.length > 0) {
        this.razonSelectedDefault2(listRazones);
        for (var list of listRazones) {
          if (list.code === '-1') {
            this.banRazonSelectedDefault = true;
            this.vaucher.razonSeleccionada = list.nombre;
            this.vaucher.razonSeleccionadaCode = '-1';

            this.creditoEmpresa.razonSeleccionada = list.nombre;
            this.creditoEmpresa.razonSeleccionadaCode = '-1';

            this.credito.razonSeleccionada = list.nombre;
            this.tiempoLimite.razonSeleccionada = list.nombre;
            this.token.razonSeleccionada = list.nombre;
          }
        }
      }
    },
    politicaSelectedDefault2(listPoliticas) {
      if (listPoliticas.length === this.contPoliticaSelectedDefault) {
        if (!this.banPoliticaSelectedDefault) {
          this.vaucher.politicaSeleccionada = listPoliticas[0].nombre;
          this.vaucher.politicaSeleccionadaCode = listPoliticas[0].code;

          this.creditoEmpresa.politicaSeleccionada = listPoliticas[0].nombre;
          this.creditoEmpresa.politicaSeleccionadaCode = listPoliticas[0].code;

          this.credito.politicaSeleccionada = listPoliticas[0].nombre;
          this.tiempoLimite.politicaSeleccionada = listPoliticas[0].nombre;
          this.token.politicaSeleccionada = listPoliticas[0].nombre;

          this.banSelectedPoliticaVaucher = true;
          this.banSelectedPoliticaCredito = true;
          this.banSelectedPoliticaToken = true;
          this.banSelectedPoliticaCreditoEmpresa = true;
          this.banSelectedPoliticaTiempoLimite = true;
        }
      } else {
        setTimeout(() => {
          this.politicaSelectedDefault2(listPoliticas);
          this.contPoliticaSelectedDefault++;
        }, 10);
      }
    },
    razonSelectedDefault2(listRazon) {
      if (listRazon.length === this.contRazonSelectedDefault) {
        if (!this.banRazonSelectedDefault) {
          this.vaucher.razonSeleccionada = listRazon[0].nombre;
          this.vaucher.razonSeleccionadaCode = listRazon[0].code;

          this.creditoEmpresa.razonSeleccionada = listRazon[0].nombre;
          this.creditoEmpresa.razonSeleccionadaCode = listRazon[0].code;

          this.credito.razonSeleccionada = listRazon[0].nombre;
          this.tiempoLimite.razonSeleccionada = listRazon[0].nombre;
          this.token.razonSeleccionada = listRazon[0].nombre;
        }
      } else {
        setTimeout(() => {
          this.razonSelectedDefault2(listRazon);
          this.contRazonSelectedDefault++;
        }, 10);
      }
    },
    frameload() {
      this.banderilla = false;
    },
    cargaToken() {
      var _this = this;
      let urlToken = process.env.VUE_APP_TOKENIZER + this.ls.get('Language').data;
      this.urlTokenizado = urlToken;
      this.HTMLcontent = '<iframe id="iframeTokenizador" style="border: none; width: 100%; height: 380px;" src="' + urlToken + '"></iframe>';
      setTimeout(() => {
        document.getElementById('iframeTokenizador').onload = function () {
          _this.frameload();
        }
      }, 100);
    },
    abrirTokenizador() {
      this.banderilla = true;
      if (this.credito.tarjetaSeleccionada != '') {
        this.HTMLcontent = '';
        this.cargaToken();

        this.modalTokenizador = true;
        this.requestTokenizador().then(response => {
          this.credito.numero = response;
          this.credito.tipoDeMascara = response;
          this.cerrarTokenizador();
        }).catch(error => {
        });
      }
    },
    cerrarTokenizador() {
      this.HTMLcontent = '';
      this.modalTokenizador = false;
      this.banderilla = true;
    },
    cancelarTokeninzador() {
      this.credito.numero = '';
      this.credito.tipoDeMascara = '';
      this.HTMLcontent = '';
      this.modalTokenizador = false;
    },
    requestTokenizador() {
      return new Promise((resolve, reject) => {
        let urlTokenizado = process.env.VUE_APP_TOKENIZER + this.ls.get('Language').data;
        window.addEventListener("message", function (event) {
          if (urlTokenizado.startsWith(event.origin)) {
            this.credito.numero = event.data;
            resolve(event.data);
          } else {
            reject(event);
          }
        });
      });
    },
    clearLocalStorage() {
      this.isExpiredModalVisible = true

    },
    // buscador
    cambiaValuePoliticaVoucher(politica, code) {
      this.vaucher.politicaSeleccionadaCode = code;
      this.banSelectedPoliticaVaucher = true;
      return this.vaucher.politicaSeleccionada = politica;
    },
    cambiaValueRazonVoucher(razon, business, code) {
      this.vaucher.razonSeleccionadaCode = code;
      this.businessRa = business
      return this.vaucher.razonSeleccionada = razon;
    },
    cambiaValuePoliticaCredito(politica) {
      this.banSelectedPoliticaCredito = true;
      return this.credito.politicaSeleccionada = politica;
    },
    cambiaValueRazonCredito(razon, business) {
      this.businessRa = business
      return this.credito.razonSeleccionada = razon;
    },
    cambiaValuePoliticaToken(politica) {
      this.banSelectedPoliticaToken = true;
      return this.token.politicaSeleccionada = politica;
    },
    cambiaValueRazonToken(razon, business) {
      this.businessRa = business
      return this.token.razonSeleccionada = razon;
    },
    cambiaValuePoliticaTiempo(politica) {
      this.banSelectedPoliticaTiempoLimite = true;
      return this.tiempoLimite.politicaSeleccionada = politica;
    },
    cambiaValueRazonTiempo(razon, business) {
      this.businessRa = business
      return this.tiempoLimite.razonSeleccionada = razon;
    },
    cambiaValuePoliticaCreditoEmpresa(politica, code) {
      this.creditoEmpresa.politicaSeleccionadaCode = code;
      this.banSelectedPoliticaCreditoEmpresa = true;
      return this.creditoEmpresa.politicaSeleccionada = politica;
    },
    cambiaValueRazonCreditoEmpresa(razon, business, code) {
      this.creditoEmpresa.razonSeleccionadaCode = code;
      this.businessRa = business
      return this.creditoEmpresa.razonSeleccionada = razon;
    },
    //KB48764 Change by m.a.cortes 
         changePolicys(policyDesc,quantity, rate,guiones,rateActive,tCliente, nights){         
       
          if(policyDesc.includes(this.twoPolicy)|| policyDesc.includes(this.twoPolicyEn)){             
            let rateUltimateTwo = quantity/nights;
            rateUltimateTwo = rateUltimateTwo.toFixed(2);  
            var twonoches= rateUltimateTwo*2;
            policyDesc= policyDesc.replace(rate,`$${twonoches.toLocaleString('en')}`);                         
          }else{                  
              let rateUltimate = quantity/nights;  
              rateUltimate = rateUltimate.toFixed(2);                 
              policyDesc= policyDesc.replace(rate,`$${rateUltimate.toLocaleString('en')}`);
          }
          if(tCliente=='PYP'||tCliente=='PYPSA'){
              if(rateActive==1){
                  policyDesc=policyDesc.replace(rate,guiones);
              }
            policyDesc=policyDesc;
            policyDesc= policyDesc.replace('$$','$' );
            return policyDesc;
            }
           policyDesc= policyDesc.replace('$$','$' );
          return policyDesc;
	  },
    cambiaCredito(tipoTarjeta) {
      return this.credito.tarjetaSeleccionada = tipoTarjeta;
    },
    cambiarMascara(code) {
      this.cardTypeForService = code
    },
    cambiaToken(tipoTarjeta, code) {
      this.tokenCreditCardType = code
      return this.token.tarjetaSeleccionada = tipoTarjeta;
    },
    // Cerrar inputs
    outsideSearchPoliticaVoucher(e) {
      this.vaucher.tipoPolitica = false;
    },
    outsideSearchRazonVoucher(e) {
      this.vaucher.tipoRazon = false;
    },
    outsideSearchPoliticaCredito(e) {
      this.credito.tipoPolitica = false;
    },
    outsideSearchRazonCredito(e) {
      this.credito.tipoRazon = false;
    },
    outsideSearchPoliticaToken(e) {
      this.token.tipoPolitica = false;
    },
    outsideSearchRazonToken(e) {
      this.token.tipoRazon = false;
    },
    outsideSearchPoliticaTiempo(e) {
      this.tiempoLimite.tipoPolitica = false;
    },
    outsideSearchRazonTiempo(e) {
      this.tiempoLimite.tipoRazon = false;
    },
    outsideSearchPoliticaCreditoEmpresa(e) {
      this.creditoEmpresa.tipoPolitica = false;
    },
    outsideSearchRazonCreditoEmpresa(e) {
      this.creditoEmpresa.tipoRazon = false;
    },
    outsideCredito(e) {
      this.credito.tipoTarjeta = false;
    },
    outsideToken(e) {
      this.token.tipoTarjeta = false;
    },
    inputValidation(event, type) {
      switch (type) {
        case 'text':
          var code = (event.which) ? event.which : event.keyCode;
          if ((code >= 33 && code <= 64) || (code >= 91 && code <= 96) || (code >= 123 && code <= 128)) {
            event.preventDefault()
          }
          return true;
          break;

        default:
          break;
      }
    },

    /*Eventos para cambios en el ancho de la pagina*/
    getWindowWidth: function (event) {
      this.windowWidth = document.documentElement.clientWidth;
      this.windowWidth > 736 ? this.device = 'desktop' : this.device = 'mobile';
    },

  },
  computed: {
    // buscador
    filteredListRazonesVoucher() {
      return this.vaucher.razones
    },
    filteredListPoliticasVoucher() {
      return this.vaucher.politicas
    },
    filteredListRazonesCredito() {
      return this.credito.razones
    },
    filteredListPoliticasCredito() {
      return this.credito.politicas
    },
    filteredListRazonesToken() {
      return this.token.razones
    },
    filteredListPoliticasToken() {
      return this.token.politicas
    },
    filteredListRazonesTiempo() {
      return this.tiempoLimite.razones
    },
    filteredListPoliticasTiempo() {
      return this.tiempoLimite.politicas
    },
    filteredListCredito() {
      return this.credito.tarjetas
    },
    filteredListToken() {
      return this.token.tarjetas
    },
    filteredListRazonesCreditoEmpresa() {
      return this.creditoEmpresa.razones
    },
    filteredListPoliticasCreditoEmpresa() {
      return this.creditoEmpresa.politicas
    },
    // Validador
    isDisabled() {
      switch (this.iconoActivo) {
        case 0:
          this.resetTarjeta();
          this.resetToken();
          this.resetCredito();
          if (
            this.vaucher.politicaSeleccionada.length > 2 && this.vaucher.razonSeleccionada.length > 2
            && this.vaucher.politicaSeleccionadaCode != '-1' && this.vaucher.razonSeleccionadaCode != '-1'
            && this.vaucher.politicaSeleccionadaCode != '' && this.vaucher.razonSeleccionadaCode != ''
            && this.aceptoAviso
            && this.banSelectedPoliticaVaucher) {
            return false;
          } else {
            return true;
          }
          break;
        case 1:
          this.resetVaucher();
          this.resetToken();
          this.resetCredito();
          if (this.credito.tarjetaSeleccionada.length > 2
            && this.credito.tipoDeMascara.length > 2
            && this.credito.numero.length > 9
            && this.credito.nombre.length > 2
            && !this.banTarCredExp
            && this.credito.expiracion != 0
            && this.aceptoAviso
            && this.banSelectedPoliticaCredito) {
            return false;
          } else {
            return true;
          }
          break;
        case 2:
          this.resetVaucher();
          this.resetTarjeta();
          this.resetCredito();
          if (this.token.tarjetaSeleccionada.length > 2
            && this.token.numero.length > 9
            && this.token.nombre.length > 2
            && this.token.expiracion.length > 2
            && !this.banTokenExp
            && this.token.expiracion != 0
            && this.aceptoAviso
            && this.banSelectedPoliticaToken) {
            return false;
          } else {
            return true;
          }
          break;
        case 3:
          this.resetVaucher();
          this.resetTarjeta();
          this.resetToken();
          this.resetCredito();
          if (this.aceptoAviso
            && this.banSelectedPoliticaTiempoLimite) {
            return false;
          } else {
            return true;
          }
          break;
        case 4:
          this.resetVaucher();
          this.resetTarjeta();
          this.resetToken();
          if (this.creditoEmpresa.politicaSeleccionada.length > 2 && this.creditoEmpresa.razonSeleccionada.length > 2
            && this.creditoEmpresa.politicaSeleccionadaCode != '-1' && this.creditoEmpresa.razonSeleccionadaCode != '-1'
            && this.creditoEmpresa.politicaSeleccionadaCode != '' && this.creditoEmpresa.razonSeleccionadaCode != ''
            && this.aceptoAviso
            && this.banSelectedPoliticaCreditoEmpresa) {
            return false;
          } else {
            return true;
          }
          break;

        default:
          return true;
          break;
      }
    },
    isDisabledCheckbox() {
      this.aceptoAviso = false;
      if (this.iconoActivo === 0 || this.iconoActivo === 3 || this.iconoActivo === 4) {
        return false;
      } else {
        if (((this.iconoActivo === 1 && (this.credito.numero !== '' && this.credito.expiracion !== '' && this.credito.nombre !== '' && this.credito.tarjetaSeleccionada !== ''))
          || (this.iconoActivo === 2 && (this.token.numero !== '' && this.token.expiracion !== '' && this.token.nombre !== '' && this.token.tarjetaSeleccionada !== '')))) {
          return false;
        } else {
          return true;
        }
      }
    },
    isDisabledTokenizador() {
      switch (this.iconoActivo) {
        case 1: // Tarjeta de crédito
          if (this.credito.tarjetaSeleccionada.length > 2) {
            return false;
          } else {
            this.credito.numero == ''
            return true;
          }
          break;
        case 2: // Token
          if (this.token.tarjetaSeleccionada.length > 2) {
            return false;
          } else {
            return true;
          }
          break;
        default:
          return true;
          break;
      }
    },
  },

  filters: {
    // buscador
    resalt: function (value, valueFromSearch) {
      if (!value) return ''
      valueFromSearch != '' ? value = value.replace(valueFromSearch, '<span class="PC-text--semibold PC-color--colorBase2">' + valueFromSearch + '</span>') : value = value;
      return value;
    }
  },
  directives: {
    'click-outside': {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) { warn += `Found in component '${compName}'` }
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler

        // add Event Listeners
        document.addEventListener('click', handler)
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  },

}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/config.scss';



.contenidoSearchCard {
  position: relative;

  .search-iconsCards {
    position: absolute;
    left: 5px;
    margin-top: 11px;
    font-size: 18px;
    color: #005a83;
    height: 34px;
  }

  .elipseCards {
    padding-left: 35px !important;
  }
}

.form-element {
  margin-top: 16px !important;
}

.voucher {
  .form-element {
    margin-top: 16px !important;
  }
}

.resaltar {
  font-weight: 500;
}

.espacio {
  display: flex;
  position: relative;
  min-height: 70vh;
  width: 100%;
  margin-top: 57px;
  padding-top: 32px;
}

.pasos {
  color: $grayBrownish;
  font-size: $font-size-biglarge;
  font-weight: 300;
}

.ativePaso {
  color: #0c5458;
  font-size: $font-size-biglarge;
  font-weight: 500;
}

.replicar {
  color: #0c5458;
  font-weight: 500;
  cursor: pointer;
}

input:disabled {
  background-color: #f8f8f8;
}

.notaAzul {
  color: $colorBase2;
  font-weight: 500;
}

// Formulario
.botones {
  margin-bottom: 45px;
}

// Habitaciones
.metodos {
  margin-top: 40px;
  margin-bottom: 80px;

  i {
    font-size: 18px;
  }

  .navi:before {
    margin-right: 10px;
  }

  .navi2 {
    float: right;
  }

  .editarDatos {
    font-size: $font-size-base;
    color: #0c5458;
    float: right;
  }

  .habitacionTitle {
    font-size: $font-size-exlarge;
    font-weight: bold;
    padding: 16px;
    background: #efece7;
  }

  .campos {
    border-bottom: 1px solid $colorBase5;

    .datos {
      padding-bottom: 24px;
    }

    .tituloDatos {
      margin: 0;
      color: $grayShadeDark;
      font-size: $font-size-large;
      font-weight: 500;
      padding-top: 24px;
      padding-bottom: 24px;
    }

    .camposActive {
      color: #0c5458;
      font-weight: 500;
    }

    .tituloDatosEditar {
      margin: 0;
      color: #006900;
      font-weight: 500;
      padding-top: 24px;
      padding-bottom: 24px;
    }
  }


  @media (max-width: 736px) {
    .buscadorCard {
      width: 185% !important;
      padding: 20px !important;
      border: 1px solid #e7e8e9 !important;
    }
  }

  .botonesInfo {
    left: 50%;
  }

  @media only screen and (max-width: 992px) {
    .botonesInfo {
      left: 0;
    }
  }
}

.barTop {
  display: none;
}

.barRight {
  display: block;
}

@media only screen and (max-width: 992px) {
  .espacio {
    margin-top: 100px;
  }

  .barTop {
    display: block;
  }

  .barRight {
    display: none;
  }
}

@media only screen and (max-width: 410px) {
  .espacio {
    margin-top: 130px;
  }
}
</style>
